import React, { useEffect, useState, useRef, useMemo } from "react";
import "./Tv.css";
import settings from "../../assets/images/settings.png";
import help from "../../assets/images/help-y.svg";
import memetv from "../../assets/images/meme-logo.svg";
import engimg from "../../assets/images/energy.svg";
import useUserInfo from "../../Hooks/useUserInfo";
import ProgressBar from "react-bootstrap/ProgressBar";
import marketPlack from "../../assets/images/marketPlace.svg";
import leaderBoarder from "../../assets/images/leaderBoard.svg";
import beatAudio from "../../assets/audio/beatmusic.mp3";
import womensaudio from "../../assets/audio/Women'sDayMusic.mp3";
import spalsh from "../../assets/images/splash.svg";
import {
  addWatchSeconds,
  getUserDetails1,
  TutorialUpdate,
} from "../../apis/user";
import BlueImageSplash from "../../assets/images/blue.png";
import GreenImageSplash from "../../assets/images/green - Copy.png";
import PinkImageSplash from "../../assets/images/pink.png";
import RedImageSplash from "../../assets/images/red.png";
import OrangeImageSplash from "../../assets/images/orange.png";
import YellowImageSplash from "../../assets/images/yellow.png";
import marketPlace from "../MarketPlace/marketPlace";
import TotalPoints from "../TotalPoints/TotalPoints";
import Phase from "../PhasePage/PhasePage";
import DoandEarn from "../DoEarn/DoEarn";
import Streak from "../Streak/Streak";
import tapSound from "../../assets/audio/taps.wav";
import { FaChevronRight } from "react-icons/fa";
import clock from "../../assets/images/clock.svg";
import LeaderBoard from "../LeaderBoard/LeaderBoard";
import inviteFriends from "../../assets/images/invitetv.svg";
import ReferPage from "../ReferPage/ReferPage";
import ConnectWalletImg from "../../assets/images/ConnectWalletImg.png";
import ConnectWallet from "../ConnectWallet/ConnectWallet";
import animepic from "../../assets/images/animepic.svg";
import cancelIcon from "../../assets/Task/cancelicon.svg";
// import weekRewards from "../../apis/user/weekRewards";
import wallet from "../../assets/images/wallet.svg";
import DashedProgressBar from "../../components/dashedprogress/Dashedprogress";
import { logPageView } from "../../components/analytics";
import { useAudio } from "../../Providers/AudioProvider";
// import cricket from "../../assets/images/Video.gif";
import womenForeGround from "../../assets/images/womens-day-spark.gif";
import {
  convertToIST,
  formatNumber,
  TutorialSlides,
} from "../../helpers/helpers";
import TutorialPage from "./Tutorial";
import { ShivRatriPopup } from "./Advertisement/ShivRatri/ShivRatri";
import Infinity from "../../assets/images/infinity.svg";
import karate from "../../assets/images/karate.png";
import shivatap from "../../assets/images/shivatap.png";
import womensImage from "../../assets/images/womens.jpg";
import unmuteIcon from "../../assets/images/audio.svg";
import muteIcon from "../../assets/images/unmute.svg";
import WomenTapBg from "../../assets/images/womens-day-tap-bg.gif";
import characker from "../../assets/images/womens day gif t.gif";
import cricMan from "../../assets/images/crick-man.jpg";
import { FiveMillionPopup } from "./Advertisement/5MillionReached/Five-Million";
import Swal from "sweetalert2";
import stadium from "../../assets/images/stadiumgif.gif";
import CountdownTimer from "./Advertisement/CountDown";
import ChooseIplTeam from "./Iplbattle/chooseteam";
import MatchScheduleList from "./Iplbattle/matchsceduleList";
import CricketGame from "./Iplbattle/cricketGame";

import {GetIplBoosterList, IplMatchData } from "../../apis/iplBattle";
import Iplwar from "./Iplbattle/ipllanding";
import { PointsTable } from "./Advertisement/Ipl-PointsTable/PointsTable";
import Gauth from "../Gauth/Gauth";
import IplLiveImg from "../../../src/assets/ipl/Ufw-Live.svg"
import LeagueSelection from "./Iplbattle/CricketCategory/selectCategory";

// import iplLive from "../../assets/ipl/ipl-live-logo.svg"
// Base values for tokens per tap
const REGULAR_USER_TOKEN_VALUE = 5;
const EARLY_USER_TOKEN_VALUE = 1;
const iplLive =
  "https://res.cloudinary.com/drviuvfle/image/upload/v1742725792/Group_1244832307_jtuhjv.png";
// const iplLive = IplLiveImg;
const Tv = (props) => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit";

  // Determine if user is an early user for token calculations
  const isEarlyUser =
    userDetails?.earlyUsersLimitReached ??
    userDetails?.user?.earlyUsersLimitReached ??
    userDetails?.userData?.earlyUsersLimitReached ??
    false;

  const isEarlyUserForWatchMinting =
    process.env.REACT_APP_IS_TOKEN_MINT_PER_SEC_TO_ONE === "true" &&
    (userDetails?.earlyUsersLimitReached ??
      userDetails?.user?.earlyUsersLimitReached ??
      userDetails?.userData?.earlyUsersLimitReached ??
      false);

  const isEarlyUserForTapMinting =
    process.env.REACT_APP_IS_TOKEN_MINT_PER_TAP_TO_ONE === "true" &&
    (userDetails?.earlyUsersLimitReached ??
      userDetails?.user?.earlyUsersLimitReached ??
      userDetails?.userData?.earlyUsersLimitReached ??
      false);

  // Function to get the token value based on user status
  const getTokenPerTap = () =>
    isEarlyUserForTapMinting
      ? EARLY_USER_TOKEN_VALUE
      : REGULAR_USER_TOKEN_VALUE;

  const [secs, setSecs] = useState(0);
  const [currentLevel, setCurrentLevel] = useState(
    userDetails.userDetails?.level
  );
  const [isTrueEnergy, setIsTrueEnergy] = useState(false);
  const userId = userDetails?.userDetails?.telegramId;
  const IsTutorial = JSON.parse(localStorage.getItem(`TutorialIcon_${userId}`));
  const FindLevel = Number(localStorage.getItem(`level_${userId}`));
  const getBoosterPoints = Number(
    localStorage.getItem(`accumulatedBoosterPoints_${userId}`)
  );
  const watchScreenRef = useRef(watchScreen);
  const currentLevelRef = useRef(userDetails.userDetails?.level);
  const getCounter = Number(localStorage.getItem(`counter_${userId}`));
  const [counter, setCounter] = useState(getCounter || 0);
  const characker =
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/womensdaynew.gif";

  const womenForeGround =
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/womensdaynewspark.gif";
  const unmuteIcon =
    "https://d1ccopf5cw1hft.cloudfront.net/s3data/image+167.png";
  const muteIcon = "https://d1ccopf5cw1hft.cloudfront.net/s3data/image+168.png";
  const cancelIcon = "https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png";
  const spalsh = "https://d1ccopf5cw1hft.cloudfront.net/s3data/splash.svg";

  const secsRef = useRef(secs);
  const secsOnlyRef = useRef(secs);
  const timeoutRef = useRef(null);
  const [tapPoints, setTapPoints] = useState(0);
  const tapPointsRef = useRef(tapPoints);
  //holi day
  const [splashes, setSplashes] = useState([]);
  const containerRef = useRef(null);

  // Generate a random bright color
  const getRandomColor = () => {
    const colors = [
      "#FF5252", // Red
      "#FFEB3B", // Yellow
      "#4CAF50", // Green
      "#2196F3", // Blue
      "#E040FB", // Purple
      "#FF9800", // Orange
      "#00BCD4", // Cyan
      "#F06292", // Pink
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const handleHoli = (e) => {
    // Prevent duplicate events (e.g., touchstart followed by click)
    if (e.type === "touchstart") {
      e.preventDefault();
    }

    const event = e.type === "touchstart" ? e.touches[0] : e;

    if (!containerRef.current) return;

    // Get click/touch position relative to the container
    const rect = containerRef.current.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Create a new splash
    const newSplash = {
      id: Date.now(),
      x,
      y,
      color: getRandomColor(),
      scale: 0,
      opacity: 0.9,
      rotation: Math.random() * 30 - 15, // slight random rotation between -15 and 15 degrees
    };

    // Add the splash to state
    setSplashes((prev) => [...prev, newSplash]);

    // Animate the splash growing and manage its lifecycle
    setTimeout(() => {
      setSplashes((prev) =>
        prev.map((splash) =>
          splash.id === newSplash.id ? { ...splash, scale: 1 } : splash
        )
      );
    }, 10);

    // Schedule the splash to fade out after displaying for a while
    setTimeout(() => {
      setSplashes((prev) =>
        prev.map((splash) =>
          splash.id === newSplash.id ? { ...splash, opacity: 0 } : splash
        )
      );
    }, 800);

    // Ensure the splash is removed after fade-out completes
    setTimeout(() => {
      setSplashes((prev) =>
        prev.filter((splash) => splash.id !== newSplash.id)
      );
    }, 900); // 800ms for fade-out + buffer
  };

  // Add event listeners for both mouse and touch events
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener("touchstart", handleHoli, { passive: false });
    container.addEventListener("click", handleHoli);

    return () => {
      container.removeEventListener("touchstart", handleHoli);
      container.removeEventListener("click", handleHoli);
    };
  }, []);

  // Add event listeners for both mouse and touch events
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Ensure only one of click or touchstart is processed
    container.addEventListener("touchstart", handleHoli, { passive: false });
    container.addEventListener("click", handleHoli);

    return () => {
      container.removeEventListener("touchstart", handleHoli);
      container.removeEventListener("click", handleHoli);
    };
  }, []);

  // end holiday

  // const audioRef = React.useRef(null);
  // const [energyy, SetEnergy] = useState(5000);
  // const energy = useRef(energyy);
  const [energyy, SetEnergy] = useState(() => {
    // Retrieve saved energy from localStorage, or default to 5000
    return Number(localStorage.getItem(`energy_${userId}`)) || 5000;
  });
  useEffect(() => {
    // Save energy value to localStorage whenever it updates
    localStorage.setItem(`energy_${userId}`, energyy);
  }, [energyy]);

  const energy = useRef(energyy);
  const [boosterPoints, setBoosterPoints] = useState(0);
  const [accumulatedPoints, setAccumulatedPoints] = useState(() => {
    // Initialize from localStorage or set to 0
    return getBoosterPoints || 0;
  });
  const [isCounterActive, setIsCounterActive] = useState(true);

  // const beatAudio =
  //   "https://res.cloudinary.com/dprlidj0p/video/authenticated/s--ZqQFVjLO--/v1740129639/om_vid_1_h4ivas.wav";

  const boosterPointsRef = useRef(boosterPoints);
  // const audioRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isTutorial, setIsTutorial] = useState(false);
  const [showInstructions, setShowInstructions] = useState("");
  const playClick = useAudio();
  const [isTapping, setIsTapping] = useState(false);
  const tapTimeoutRef = useRef(null); // Add this to track the timeout
  const [isMuted, setIsMuted] = useState(() => {
    const savedMuteState = localStorage.getItem(`isMuted_${userId}`);
    return savedMuteState ? JSON.parse(savedMuteState) : false;
  });

  const options = [
    {
      label: "WOMEN'S DAY",
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/womens.jpg", // Replace with the actual image path
      section: "womensday",
      audio: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Women'sDayMusic.mp3",
    },
    {
      label: "karateka",
      image: karate, // Replace with the actual image path
      section: "memetvGuy",
      audio: "https://d1ccopf5cw1hft.cloudfront.net/s3data/beatmusic.mp3",
    },
    {
      label: "Mahadev",
      image: "https://d1ccopf5cw1hft.cloudfront.net/s3data/shivatap.png", // Replace with the actual image path
      section: "shivaratri",
      audio: "https://d1ccopf5cw1hft.cloudfront.net/s3data/om_vid_1_h4ivas.wav",
    },
    {
      label: "Ipl",
      image: cricMan, // Replace with the actual image path
      section: "Ipl",
      audio: "https://d1ccopf5cw1hft.cloudfront.net/s3data/crowd+sound_1.mp3",
    },
  ];

  // State to track the selected option and audio instance
  const [selectedOption, setSelectedOption] = useState(options[1]);
  const [audioInstance, setAudioInstance] = useState(null);

  // Handle visibility change
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (audioInstance) {
        if (document.visibilityState === "hidden") {
          // App is minimized/hidden
          console.log("App minimized, pausing audio");
          audioInstance.pause();
        } else if (document.visibilityState === "visible") {
          // App is visible/active again
          console.log("App visible, resuming audio");
          audioInstance.play().catch((error) => {
            console.error("Error resuming audio:", error);
          });
        }
      }
    };

    // Add visibility change listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [audioInstance]);

  // Play audio whenever the selected option changes
  useEffect(() => {
    if (!selectedOption) return;

    // Stop current audio if playing
    if (audioInstance) {
      audioInstance.pause();
    }

    // Create and play new audio
    const newAudio = new Audio(selectedOption.audio);
    newAudio.loop = true;
    newAudio.muted = isMuted; // Apply current mute state to new audio
    setAudioInstance(newAudio);

    // Only start playing if the page is visible
    if (document.visibilityState === "visible") {
      newAudio.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
    }

    // Cleanup audio on unmount
    return () => {
      if (newAudio) {
        newAudio.pause();
        newAudio.currentTime = 0;
      }
    };
  }, [selectedOption, isMuted]); // Add isMuted to dependencies

  const handleOptionClick = (option) => {
    setSelectedOption(option); // Update selected option
  };

  const toggleMute = () => {
    if (audioInstance) {
      const newMuteState = !isMuted;
      audioInstance.muted = newMuteState;
      setIsMuted(newMuteState);
      // Save mute state to localStorage
      localStorage.setItem(`isMuted_${userId}`, JSON.stringify(newMuteState));
    }
  };

  let tapTimeout;
  // Increment key to force re-render // Small delay to restart animation}
  const handleTapEnd = (event) => {
    if (tapTimeout) clearTimeout(tapTimeout);
    tapTimeout = setTimeout(() => {
      setIsTapping(false); // Use setIsTapping instead of setIsTapped
    }, 3000); // Delay before stopping the floating effect
    //  setTimeout(() => {
    //   setIsTapped(false)
    // }, 3000); // Small delay to prevent flickering
    // setIsTapped(false)
  };

  useEffect(() => {
    logPageView(selectedOption.section, selectedOption.section);
  }, [selectedOption.section]);
  const latestUserDetails = useRef(userDetails);
  // useEffect(() => {
  //   boosterPointsRef.current = boosterPoints;
  //   if (
  //     latestUserDetails.current.currentComponentText == "TVPage" &&
  //     watchScreen?.booster
  //   ) {
  //     setCounter((prevCounter) => {
  //       const newCounter = prevCounter + 1;
  //       localStorage.setItem(`counter_${userId}`, newCounter);
  //       return newCounter;
  //     });

  //   }
  // }, [latestUserDetails,watchScreen]);
  const handleClick = () => {
    if (watchScreen.booster) {
      // Show instructions when booster is true
      setShowInstructions(true);

      // Automatically hide instructions after 3 seconds (3000 milliseconds)
      setTimeout(() => {
        setShowInstructions(false);
        props?.setOpenWhileBooster(false);
      }, 3000);
    }
  };
  const scrollableRef = useRef(null);

  useEffect(() => {
    const preventTouchScroll = (event) => {
      let targetElement = event.target;
      while (targetElement) {
        if (targetElement.getAttribute?.("data_-scrollable") === "true") {
          return;
        }
        targetElement = targetElement.parentElement;
      }
      event.preventDefault();
    };
    document.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    return () => {
      document.removeEventListener("touchmove", preventTouchScroll);
    };
  }, []);

  useEffect(() => {
    console.log(JSON.stringify(watchScreen.booster) + "watchScreenwatchScreen");
    if (props?.openWhileBooster) {
      handleClick();
    }
    // Function to start the counter
    // const startCounter = () => {
    //   if (!intervalRef.current) {
    //     console.log("App is in the foreground, starting counter...");
    //     intervalRef.current = setInterval(() => {
    //       setCount((prevCount) => prevCount + 1);
    //     }, 1000); // Increment the counter every second
    //   }
    // };

    // Function to pause the counter
    // const pauseCounter = () => {
    //   if (intervalRef.current) {
    //     console.log("App went to the background, pausing counter...");
    //     clearInterval(intervalRef.current); // Clear the interval to pause counting
    //     intervalRef.current = null; // Reset the ref
    //   }
    // };

    // Add event listeners for window focus and blur
    // window.addEventListener("focus", startCounter);
    // window.addEventListener("blur", pauseCounter);

    // // Start the counter when the app first loads
    // startCounter();

    // Cleanup event listeners and stop the counter when the component unmounts
    return () => {
      // window.removeEventListener("focus", startCounter);
      // window.removeEventListener("blur", pauseCounter);
      // pauseCounter(); // Clear the interval when the component is unmounted
    };
  }, [watchScreen, props?.openWhileBooster]);

  useEffect(() => {
    // Function to start the counter
    const startCounter = () => {
      // if (!intervalRef.current) {
      //   intervalRef.current = setInterval(() => {
      //     setCount((prevCount) => prevCount + 1);
      //   }, 1000); // Increment the counter every second
      // }
    };

    // Function to pause the counter
    const pauseCounter = () => {
      // if (intervalRef.current) {
      console.log("App went to the background, pausing counter...");
      //   clearInterval(intervalRef.current); // Clear the interval to pause counting
      //   intervalRef.current = null; // Reset the ref
      // }
    };

    // Add event listeners for window focus and blur
    window.addEventListener("focus", startCounter);
    window.addEventListener("blur", pauseCounter);

    // // Start the counter when the app first loads
    startCounter();
    // Cleanup event listeners and stop the counter when the component unmounts
    return () => {
      window.removeEventListener("focus", startCounter);
      window.removeEventListener("blur", pauseCounter);
      pauseCounter(); // Clear the interval when the component is unmounted
    };
  }, []);
  const boosterValues = useMemo(() => {
    return {
      levelUp: isEarlyUserForWatchMinting ? 1 + 1 : currentLevelRef.current + 1,
      "2x": isEarlyUserForWatchMinting ? 1 * 2 : currentLevelRef.current * 2,
      "3x": isEarlyUserForWatchMinting ? 1 * 3 : currentLevelRef.current * 3,
      "5x": isEarlyUserForWatchMinting ? 1 * 5 : currentLevelRef.current * 5,
      "tap":isEarlyUserForWatchMinting ? 1 : currentLevelRef.current,
    };
  }, [currentLevelRef.current]);
  const BoosterPerSec = boosterValues[watchScreenRef.current?.boosterDetails?.name]
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        console.log("Page hidden, clearing interval...");
        clearInterval(intervalRef.current);
      } else {
        console.log("Page visible, starting interval...");
        intervalRef.current = setInterval(() => {
          localStorage.setItem(
            `pointDetails_${userId}`,
            JSON.stringify({
              tapPoints: tapPointsRef.current,
              watchSec: secsOnlyRef.current,
              boosterPoints: boosterPointsRef.current,
              booster: [watchScreenRef.current.boosterDetails.name],
              count: watchScreenRef.current.boosterDetails.count,
            })
          );
          if (!IsPointsReached) {
            secsOnlyRef.current += 1;
          }

          if (energy.current < 5000 && energy.current !== 4999) {
            SetEnergy((prev) => {
              const newEnergy = Number(prev) + 2;
              energy.current = newEnergy;
              localStorage.setItem(`energy_${userId}`, newEnergy);
              return newEnergy;
            });
          } else {
            SetEnergy(5000);
            energy.current = 5000;
            localStorage.setItem(`energy_${userId}`, 5000);
          }

          if (
            ["levelUp", "2x", "3x", "5x"].includes(
              watchScreenRef.current?.boosterDetails?.name
            ) &&
            !IsPointsReached
          ) {
            const boosterName = watchScreenRef.current?.boosterDetails?.name;
            setBoosterPoints(
              (prevBoosterPoints) =>
                prevBoosterPoints + boosterValues[boosterName]
            );
            boosterPointsRef.current += boosterValues[boosterName];

            setAccumulatedPoints((prevAccumulatedPoints) => {
              const newAccumulatedPoints =
                prevAccumulatedPoints + boosterValues[boosterName];
              localStorage.setItem(
                `accumulatedBoosterPoints_${userId}`,
                newAccumulatedPoints
              ); // Persist in localStorage
              return newAccumulatedPoints;
            });
          } else {
            if (!IsPointsReached) {
              setSecs((prevSecs) => {
                const newSecs =
                  prevSecs +
                  (isEarlyUserForWatchMinting ? 1 : currentLevelRef.current);
                secsRef.current = newSecs;
                return newSecs;
              });
            }
          }
        }, 1000);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    const storedData = localStorage.getItem(`tutorial_${userId}`);
    const data = JSON.parse(storedData);
    if (data && data.watched) {
      updateUserInfo((prev) => ({
        ...prev,
        isTutorial: false,
      }));
    }
    return () => {
      console.log("Cleanup: clearing interval and removing event listener");
      clearInterval(intervalRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  useEffect(() => {
    const WatchStreakData = localStorage.getItem(`watchStreak_${userId}`);
    const parsedWatchStreakData = JSON.parse(WatchStreakData);
    intervalRef.current = setInterval(() => {
      localStorage.setItem(
        `pointDetails_${userId}`,
        JSON.stringify({
          // totalReward: totalRewardPoints,
          tapPoints: tapPointsRef.current,
          watchSec: secsOnlyRef.current,
          boosterPoints: boosterPointsRef.current,
          booster: [watchScreenRef.current.boosterDetails.name],
          count: watchScreenRef.current.boosterDetails.count,
        })
      );
      localStorage.setItem(
        `watchStreak_${userId}`,

        JSON.stringify({
          // totalReward: totalRewardPoints,

          watchSec:
            parsedWatchStreakData?.date ===
            // dateAlone ===
            new Date(userDetails?.userDetails?.lastLogin).getDate()
              ? parsedWatchStreakData?.watchSec + secsOnlyRef.current
              : secsOnlyRef.current,
          // date: new Date(userDetails?.userDetails?.lastLogin).getDate(),
          // date: new Date().getDate(),
          date: new Date(userDetails?.userDetails?.lastLogin).getDate(),
          updated: parsedWatchStreakData?.updated
            ? parsedWatchStreakData?.updated
            : false,
        })
      );
      if (!IsPointsReached) {
        secsOnlyRef.current += 1;
      }
      if (energy.current < 5000 && energy.current !== 4999) {
        const newEnergy = SetEnergy((prev) => {
          return Number(prev) + 2;
        });
        energy.current = Number(energy.current) + 2;
        localStorage.setItem(`energy_${userId}`, newEnergy);
      } else {
        SetEnergy(5000);
        energy.current = 5000;
        localStorage.setItem(`energy_${userId}`, 5000);
      }
      const values = {
        levelUp: isEarlyUserForWatchMinting
          ? 1 + 1
          : currentLevelRef.current + 1,
        "2x": isEarlyUserForWatchMinting ? 1 * 2 : currentLevelRef.current * 2,
        "3x": isEarlyUserForWatchMinting ? 1 * 3 : currentLevelRef.current * 3,
        "5x": isEarlyUserForWatchMinting ? 1 * 5 : currentLevelRef.current * 5,
      };
      if (
        (watchScreenRef.current?.boosterDetails?.name === "levelUp" ||
          watchScreenRef.current?.boosterDetails?.name === "2x" ||
          watchScreenRef.current?.boosterDetails?.name === "3x" ||
          watchScreenRef.current?.boosterDetails?.name === "5x") &&
        !IsPointsReached
      ) {
        setBoosterPoints(
          (prevBoosterPoints) =>
            prevBoosterPoints +
            values[watchScreenRef.current?.boosterDetails?.name]
        );
        boosterPointsRef.current +=
          values[watchScreenRef.current?.boosterDetails?.name];
        setAccumulatedPoints((prevAccumulatedPoints) => {
          const newAccumulated =
            prevAccumulatedPoints +
            values[watchScreenRef.current?.boosterDetails?.name];
          localStorage.setItem(
            `accumulatedBoosterPoints_${userId}`,
            newAccumulated
          ); // Persist in localStorage
          return newAccumulated;
        });
      } else {
        if (!IsPointsReached) {
          setSecs((prevSecs) => {
            const newSecs =
              prevSecs +
              (isEarlyUserForWatchMinting ? 1 : currentLevelRef.current);
            secsRef.current = newSecs;
            return newSecs;
          });
        }
      }
    }, 1000);
  }, []);

  const level = isEarlyUser
    ? {
        1: 0,
        2: 10000,
        3: 50000,
        4: 150000,
        5: 500000,
        6: 1000000,
        7: 2500000,
        8: 5000000,
        9: 7500000,
        10: 10000000,
      }
    : {
        1: 500,
        2: 10000,
        3: 50000,
        4: 200000,
        5: 800000,
        6: 3000000,
        7: 10000000,
        8: 25000000,
        9: 50000000,
        10: 80000000,
      };

  const intervalRef = useRef(null);
  const [tapAnimations, setTapAnimations] = useState([]);

  useEffect(() => {
    const EnergyDetails = localStorage.getItem(`energyDetails_${userId}`);

    if (EnergyDetails) {
      try {
        const parsedEnergyDetails = JSON.parse(EnergyDetails);
        const EnergyDate = new Date(parsedEnergyDetails.date);
        const currentDate = new Date();

        const timeDifferenceInSeconds = Math.floor(
          (currentDate - EnergyDate) / 1000
        );
        const energyIncrement = timeDifferenceInSeconds;
        const newEnergy = parsedEnergyDetails.energy + energyIncrement;

        if (newEnergy >= 5000) {
          SetEnergy(5000);
          energy.current = 5000;
          localStorage.setItem(`energy_${userId}`, 5000);
        } else if (String(newEnergy)?.includes("-")) {
          SetEnergy((prev) => Number(prev) + 2);
          energy.current += 2;
          localStorage.setItem(`energy_${userId}`, newEnergy);
        } else {
          SetEnergy(newEnergy.toFixed());
          energy.current = newEnergy.toFixed();
          localStorage.setItem(`energy_${userId}`, newEnergy);
        }
      } catch (error) {
        console.error("Error parsing stored data:", error);
      }
    }

    // Cleanup interval on component unmount
    return () => {
      clearInterval(intervalRef.current);
      localStorage.setItem(
        `energyDetails_${userId}`,
        JSON.stringify({
          energy: energy.current,
          date: new Date(),
        })
      );
      addTotalPoints();
    };
  }, []);
  const EnergyStartDate = process.env.REACT_APP_ENERGY_START;
  const EnergyStartEnd = process.env.REACT_APP_ENERGY_END;

  // localStorage.setItem("IsPointsReach",IsPointsReached);
  const inputDate = userDetails?.userDetails?.updatedAt;
  // const istDate = convertToIST(inputDate);
  const [Is5million, setIs5million] = useState(
    localStorage.getItem(`IsPointsReach${userId}`) === "true"
  );
   //Do not remove this commented code
  // const [IsPointsTable, setIsPointsTable] = useState(
  //   localStorage.getItem(`IsPointsTable_${userId}`) === "true"
  // );
  const [IsPointsTable, setIsPointsTable] = useState(false );
  const [isHoliActive, setIsHoliActive] = useState(false);

  useEffect(() => {
    // const checkTime = () => {
    //   const startTime = new Date(EnergyStartDate);
    //   const endTime = new Date(EnergyStartEnd);
    //   const now = new Date();

    //   // setIsTrueEnergy(now >= startTime && now <= endTime);
    // };

    // checkTime(); // Initial check
    // const interval = setInterval(checkTime, 1000); // Check every second

    // return () => clearInterval(interval); // Cleanup
    const checkHoliStatus = () => {
      const currentDate = new Date();
      const holiDate = new Date("2025-03-14");

      // Check if the current date is March 14, 2025
      const isSameDay =
        currentDate.getFullYear() === holiDate.getFullYear() &&
        currentDate.getMonth() === holiDate.getMonth() &&
        currentDate.getDate() === holiDate.getDate();

      setIsHoliActive(isSameDay);
    };

    // Check immediately and then update every minute
    checkHoliStatus();
    const interval = setInterval(checkHoliStatus, 60000); // Check every 1 min

    return () => clearInterval(interval); // Cleanup on unmount
  }, [IsPointsReached]);
  const Close5Million = () => {
    setIs5million(false);
    localStorage.setItem(`IsPointsReach${userId}`, false);
  };
  const goToTheRefererPage = (component, name) => {
    setIsLoading(true);
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.userDetails.currentComponent,
      lastComponentText: userDetails.userDetails.currentComponentText,
      refererCount: userDetails.userDetails.refererCount + 1,
    }));
  };

  const addTotalPoints = () => {
    const totalRewardPoints =
      Number(watchScreen.totalReward) +
      Number(secsRef.current) +
      Number(tapPointsRef.current) +
      Number(boosterPointsRef.current);

    updatewatchScreenInfo((prev) => ({
      ...prev,
      totalReward: totalRewardPoints,
      tapPoints: watchScreen.tapPoints + tapPointsRef.current,
      watchSec: watchScreen.watchSec + secsOnlyRef.current,
      boosterPoints: watchScreen.boosterPoints + boosterPointsRef.current,
    }));
  };

  const [accumulatedWatchSec, setAccumulatedWatchSec] = useState(0);
  const [watchSec, setWatchSec] = useState(0); // Simulates the watch seconds
  const intervalReference = useRef(null);

  const addWatchSecapi = async (data) => {
    let apiResponse = null;

    // Set a timeout to ensure the points reset even if the API call is delayed
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve("timeout");
      }, 10000); // Adjust the timeout duration (in milliseconds) as needed
    });

    try {
      // Race the API call with the timeout
      apiResponse = await Promise.race([addWatchSeconds(data), timeout]);

      if (apiResponse === "timeout") {
        console.warn("API call timed out. Resetting points.");
      } else {
        // API call succeeded
        const res = apiResponse;

        // Reset localStorage point details
        localStorage.setItem(
          `pointDetails_${userId}`,
          JSON.stringify({
            tapPoints: 0,
            watchSec: 0,
            boosterPoints: 0,
            booster: [0],
            count: 0,
          })
        );

        // Update UI and state based on API response
        updatewatchScreenInfo((prev) => ({
          ...prev,
          totalReward: res?.balanceRewards,
          tapPoints: 0,
          booster: false,
          boosterSec: 0,
          boosterPoints: 0,
          boosterDetails: {},
          watchSec: 0,
          updatedWatchPoints: res?.watchRewards,
        }));
      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      // Reset state regardless of API success or timeout
      setBoosterPoints(0);
      setSecs(0);
      setTapPoints(0);
      setCounter(0);

      secsRef.current = 0;
      tapPointsRef.current = 0;
      boosterPointsRef.current = 0;
      secsOnlyRef.current = 0;
      localStorage.setItem(`accumulatedBoosterPoints_${userId}`, 0);
      localStorage.setItem(`counter_${userId}`, 0);
      setAccumulatedPoints(0);
    }
  };

  // Load data on component mount
  useEffect(() => {
    const storedAccumulatedSec = localStorage.getItem(
      `accumulatedWatchSec_${userId}`
    );
    const storedDate = localStorage.getItem(`lastUpdateDate_${userId}`);
    const currentDate = new Date().toISOString().split("T")[0];

    if (storedDate !== currentDate) {
      setAccumulatedWatchSec(0);
      localStorage.setItem(`lastUpdateDate_${userId}`, currentDate);
    } else if (storedAccumulatedSec) {
      setAccumulatedWatchSec(Number(storedAccumulatedSec));
    }
  }, []);

  // Save accumulatedWatchSec to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(`accumulatedWatchSec_${userId}`, accumulatedWatchSec);
    localStorage.setItem(
      `lastUpdateDate_${userId}`,
      new Date().toISOString().split("T")[0]
    );
  }, [accumulatedWatchSec]);

  // Update accumulatedWatchSec every second
  useEffect(() => {
    intervalReference.current = setInterval(() => {
      setWatchSec((prev) => prev + 1); // Increment watchSec by 1 every second
      setAccumulatedWatchSec((prev) => prev + 1); // Increment accumulatedWatchSec
    }, 1000);

    return () => {
      clearInterval(intervalReference.current);
    };
    // Clear interval on component unmount
  }, []);

  const addWatchSecapiMarket = async (data) => {
    const res = await addWatchSeconds(data);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      totalReward: res?.balanceRewards,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards,
    }));
    if (res) {
      goToThePage(marketPlace, "marketPlace");
    }
  };

  const addWatchSecapiTotal = async (data) => {
    playClick();
    setIsLoading(true);
    clearInterval(intervalRef.current);
    const res = await addWatchSeconds(data);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      // totalReward: res.balanceRewards,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards,
      allrewards: res?.balanceRewards,
    }));
    if (res) {
      setTimeout(() => {
        goToThePage(TotalPoints, "TotalPoints");
      }, 500);
    }
  };

  const addWatchSecapiStreak = async (data, name) => {
    playClick();
    setIsLoading(true);
    clearInterval(intervalRef.current);
    const res = await addWatchSeconds(data);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      // totalReward: res.balanceRewards,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards,
      allrewards: res?.balanceRewards,
    }));
    if (res) {
      setTimeout(() => {
        if (name) {
          goToThePage(LeaderBoard, "LeaderBoard");
        } else {
          goToThePage(Streak, "Streak");
        }
      }, 500);
    }
  };

  const addWatchSecapihelp = async (data) => {
    // setIsLoading(true);
    // clearInterval(intervalRef.current);
    // const res = await addWatchSeconds(data);
    // localStorage.setItem(
    //   `pointDetails_${userId}`,
    //   JSON.stringify({
    //     tapPoints: 0,
    //     watchSec: 0,
    //     boosterPoints: 0,
    //     booster: [0],
    //   })
    // );
    // updatewatchScreenInfo((prev) => ({
    //   ...prev,
    //   // totalReward: res.balanceRewards,
    //   tapPoints: 0,
    //   booster: false,
    //   boosterSec: 0,
    //   boosterPoints: 0,
    //   boosterDetails: {},
    //   watchSec: 0,
    //   updatedWatchPoints: res?.watchRewards,
    //   allrewards: res.balanceRewards,
    // }));
    // if (res) {
    //   setTimeout(() => {
    //     // goToThePage(Streak, "Streak");
    //     goToThePage(Info, "Info");
    //   }, 500);
    // }

    updateUserInfo((prev) => ({
      ...prev,
      // currentComponent: component,
      // currentComponentText: name,
      // lastComponent: userDetails.currentComponent,
      // lastComponentText: userDetails.currentComponentText,
      // centerCount: userDetails.centerCount + 1,
      isTutorial: true,
    }));

    localStorage.setItem(`TutorialIcon_${userId}`, false);
    // setIsTutorial(true);
  };

  useEffect(() => {
    const Tutorialdata = localStorage.getItem(`tutorial_${userId}`);
    const parsedTutorialData = JSON.parse(Tutorialdata);
    if (parsedTutorialData?.watched) {
      setIsTutorial(false);
    } else {
      setIsTutorial(true);
    }
  }, []);

  const addWatchSecapiwallet = async (data) => {
    // return false
    playClick();
    setIsLoading(true);
    clearInterval(intervalRef.current);
    const res = await addWatchSeconds(data);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      // totalReward: res.balanceRewards,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards,
      allrewards: res?.balanceRewards,
    }));
    if (res) {
      setTimeout(() => {
        goToThePage(ConnectWallet, "ConnectWallet");
      }, 500);
    }
  };

  const addWatchSecapirefer = async (data) => {
    playClick();
    setIsLoading(true);
    clearInterval(intervalRef.current);
    const res = await addWatchSeconds(data);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      // totalReward: res.balanceRewards,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards,
      allrewards: res?.balanceRewards,
    }));
    if (res) {
      setTimeout(() => {
        goToTheRefererPage(ReferPage, "ReferPage");
      }, 500);
    }
  };
  const NavigateDoEarn = async () => {
    playClick();
    setIsLoading(true);
    clearInterval(intervalRef.current);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    goToThePage(DoandEarn, "DoandEarn");
    await IsPromoClose();
  };
  const addWatchSecapicheap = async (data) => {
    playClick();
    setIsLoading(true);
    clearInterval(intervalRef.current);
    const res = await addWatchSeconds(data);

    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      // totalReward: res.balanceRewards,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards,
      allrewards: res?.balanceRewards,
    }));
    if (res) {
      setTimeout(() => {
        goToThePage(DoandEarn, "DoandEarn");
      }, 500);
    }
  };

  const addWatchSecapiStake = async (data) => {
    playClick();
    setIsLoading(true);
    const res = await addWatchSeconds(data);
    // const res1 = await weekRewards(data);

    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
    updatewatchScreenInfo((prev) => ({
      ...prev,
      totalReward: res?.balanceRewards ? res?.balanceRewards : 0,
      tapPoints: 0,
      booster: false,
      boosterSec: 0,
      boosterPoints: 0,
      boosterDetails: {},
      watchSec: 0,
      updatedWatchPoints: res?.watchRewards ? res?.watchRewards : 0,
      // stakeDetails: res1,
    }));
    if (res) {
      goToThePage(Phase, "Phase");
    }
  };

  useEffect(() => {
    Object.keys(level).forEach((lvl) => {
      if (
        Number(watchScreen?.totalReward + secs + tapPoints + boosterPoints) >=
        Number(level[lvl])
      ) {
        setCurrentLevel(Number(lvl));
        currentLevelRef.current = Number(lvl);
      }
    });
  }, [tapPoints, secs]);

  // Define the ref outside of useEffect
  const apiCalled = useRef(false);
  const BoosterCalled = useRef(false);
  const GetPointDetails = JSON.parse(
    localStorage.getItem(`pointDetails_${userId}`)
  );
  const WatchSecPoint = GetPointDetails?.watchSec;
  const GetTapPoint = GetPointDetails?.tapPoints;
  const GetBoosterPoints = GetPointDetails?.boosterPoints;
  const BoosterVal =
    watchScreen.boosterDetails.name == "5x"
      ? 180
      : watchScreen.boosterDetails.name == "3x"
      ? 120
      : 60;

  useEffect(() => {
    watchScreenRef.current = watchScreen;

    if (
      WatchSecPoint >= 60 &&
      !apiCalled.current &&
      !watchScreen?.booster &&
      !IsPointsReached
    ) {
      apiCalled.current = true;
      var data = {
        userWatchSeconds: WatchSecPoint,
        boosterPoints: String(boosterPointsRef.current),
        tapPoints: String(tapPointsRef.current),
      };
      addWatchSecapi(data).finally(() => {
        apiCalled.current = false; // Reset after API call completion
      });
    }
    if (watchScreen)
      if (
        watchScreen?.booster &&
        watchScreen?.boosterSec === 0 &&
        !apiCalled?.current
      ) {
        localStorage.removeItem(`BoosterSlide_${userId}`);
        setIsLoading(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 3000);
        apiCalled.current = true; // Mark as called
        // Calculate booster points correctly based on user type
        let boosterPointsToSend;
        if (watchScreen.boosterDetails.name == "tap") {
          // For tap booster, send the accumulated booster points directly
          boosterPointsToSend = String(boosterPointsRef.current);
        } else {
          // For other boosters, calculate based on user type
          if (isEarlyUserForWatchMinting) {
            // Early users: subtract 1 point per second instead of level-based points
            boosterPointsToSend = String(boosterPointsRef.current - BoosterVal * 1);
          } else {
            // Regular users: subtract level-based points per second
            boosterPointsToSend = String(boosterPointsRef.current - BoosterVal * currentLevel);
          }
        }
        
        const data = {
          userWatchSeconds: BoosterVal,
          boosterPoints: boosterPointsToSend,
          boosters: watchScreen.booster
            ? [
                {
                  type: watchScreen?.boosterDetails?.name,
                  count: watchScreen?.boosterDetails?.count,
                },
              ]
            : undefined,
        };
        // Call the API
        addWatchSecapi(data).finally(() => {
          apiCalled.current = false; // Reset after API call completion
        });
      } else if (
        watchScreen.booster &&
        watchScreen.boosterSec === BoosterVal &&
        !apiCalled.current
      ) {
        apiCalled.current = true; // Mark as called
        var data = {
          userWatchSeconds: WatchSecPoint,
          boosterPoints: String(
            tapPointsRef.current + boosterPointsRef.current
          ),
        };

        // Call the API
        UpdateWatchSec(data).finally(() => {
          apiCalled.current = false; // Reset after API call completion
        });
      }
  }, [watchScreen, secs]);
  const UpdateWatchSec = async (data) => {
    const res = await addWatchSeconds(data);
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count: 0,
      })
    );
  };

  const audioContextRef = useRef(null);
  const audioBufferRef = useRef(null);
  const audioCooldownRef = useRef(false); // Cooldown to prevent overlapping sounds
  const [audioLoaded, setAudioLoaded] = useState(false); // To track audio load status

  const tapSoundUrl = tapSound; // Replace with your actual audio URL

  useEffect(() => {
    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext ||
        window.webkitAudioContext)();
    }

    // Only load audio if not already loaded
    if (!audioBufferRef.current) {
      // Fetch and decode audio
      fetch(tapSoundUrl)
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => {
          return audioContextRef.current.decodeAudioData(arrayBuffer);
        })
        .then((audioBuffer) => {
          console.log("Audio loaded successfully");
          audioBufferRef.current = audioBuffer; // Store the decoded audio buffer in the ref
          setAudioLoaded(true); // Set the state to indicate audio is loaded
        })
        .catch((error) => {
          console.error("Error loading audio:", error);
        });
    }

    // Clean up when the component is unmounted
    return () => {
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }
    };
  }, [tapSoundUrl]); // The effect will only run once, unless tapSoundUrl changes

  // Play the sound when triggered
  const playSound = () => {
    if (audioCooldownRef.current || !audioBufferRef.current) return;
    audioCooldownRef.current = true;

    const source = audioContextRef.current.createBufferSource();
    source.buffer = audioBufferRef.current;
    source.connect(audioContextRef.current.destination);
    source.start(0); // Play sound immediately

    // Reset cooldown
    setTimeout(() => {
      audioCooldownRef.current = false;
    }, 100); // Cooldown period to prevent overlapping sounds
  };

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      centerCount: userDetails.centerCount + 1,
    }));
  };
  const [lastInputWasTouch, setLastInputWasTouch] = useState(false);

  // const handleTap = (e) => {
  //   if (energy.current > 5) {
  //     // if (navigator.vibrate) {
  //     //   navigator.vibrate(100);
  //     // }
  //     // Determine if the event is from a touch or mouse
  //     // const isTouchEvent = e.type === "touchstart";
  //     // If it's a touch event, mark it as touch
  //     // if (isTouchEvent) {
  //     //   setLastInputWasTouch(true);
  //     // } else if (lastInputWasTouch && !isTouchEvent) {
  //     //   // If the last input was a touch and now it's a click, ignore it
  //     //   return;
  //     // }
  //     tapSound.play();
  //     const touches = e.touches
  //       ? Array.from(e.touches)
  //       : [{ clientX: e.clientX, clientY: e.clientY }];
  //     let num = 5;
  //     if (watchScreen?.boosterDetails?.name === "tap" && watchScreen?.booster) {
  //       num = 10;
  //       setBoosterPoints((prevBoosterPoints) => {
  //         const newBoosterPoints = prevBoosterPoints + num * touches.length;
  //         boosterPointsRef.current = newBoosterPoints;
  //         return newBoosterPoints;
  //       });
  //     } else {
  //       if (energyy > 0) {
  //         const totalPoints = Math.min(energyy, num * touches.length);
  //         setTapPoints((prevTapPoints) => {
  //           const newTapPoints = prevTapPoints + totalPoints;
  //           tapPointsRef.current = newTapPoints;
  //           return newTapPoints;
  //         });
  //         SetEnergy((prev) => {
  //           const newEnergy = prev - totalPoints;
  //           energy.current = newEnergy;
  //           localStorage.setItem(
  //             `energyDetails_${userId}`,
  //             JSON.stringify({
  //               energy: newEnergy,
  //               date: new Date(),
  //             })
  //           );
  //           return newEnergy;
  //         });
  //       }
  //     }
  //     // const newAnimations = touches.map((touch) => ({
  //     //   id: Date.now() + Math.random(),
  //     //   x: touch.clientX,
  //     //   y: touch.clientY,
  //     // }));
  //     // setTapAnimations((prev) => [...prev, ...newAnimations]);
  //     // setTimeout(() => {
  //     //   setTapAnimations((prev) =>
  //     //     prev.filter((animation) => !newAnimations.includes(animation))
  //     //   );
  //     // }, 1000);
  //   }
  // };
  function generateBiasedRandom() {
    const rand = Math.random();

    if (rand < 0.3) {
      // 30% chance: Numbers between 1-5
      return Math.floor(Math.random() * 5) + 1;
    } else if (rand < 0.8) {
      // 50% chance (30% + 50% = 80%): Numbers between 5-25
      return Math.floor(Math.random() * 21) + 5;
    } else if (rand < 0.95) {
      // 15% chance (80% + 15% = 95%): Numbers between 25-50
      return Math.floor(Math.random() * 26) + 25;
    } else {
      // 5% chance (95% + 5% = 100%): Numbers between 50-99
      return Math.floor(Math.random() * 50) + 50;
    }
  }

  const [basePoints, setBasePoints] = useState(
    IsPointsReached ? 0 : getTokenPerTap()
  ); // Using the function to get the token value
  const IsTapBooster =
    watchScreen?.boosterDetails?.name === "tap" && watchScreen?.booster;
  const NormalBooster =
    watchScreen?.boosterDetails?.name !== "tap" && watchScreen?.booster;
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isAnimating, setIsAnimating] = useState(false);

  const [isAnimaeTap, setAnimaeTap] = useState(0); // New state to track tap points
  const isAnimationTime = useRef(0);

  const resetTimeout = useRef(null); // Ref for managing timeout
  const secsForImage =
    selectedOption.section === "shivaratri" || isAnimaeTap == 1000
      ? 3000
      : selectedOption.section == "memetvGuy"
      ? 3000
      : isAnimaeTap;

  useEffect(() => {
    if (isAnimating) {
      const timer = setTimeout(() => setIsAnimating(false), secsForImage);
      return () => clearTimeout(timer);
    }
  }, [isAnimating, isAnimaeTap]);

  const handleTapStart = (e) => {
    if (isAnimating) return;

    setPosition({ x: e.clientX, y: e.clientY });
    setIsAnimating(true);
  };
  //Do not delete this UseEffect
  // useEffect(()=>{
  //   // if (!isTrueEnergy && !IsTapBooster){
  //   //   setBasePoints(5);
  //   // }
  //   // tapSound.play();
  // // else if (isTrueEnergy && !IsTapBooster) {
  // //     setBasePoints(generateBiasedRandom());
  // // } else if (IsTapBooster && isTrueEnergy) {
  // //     setBasePoints(generateBiasedRandom()*10);
  // // }
  // // else if (IsTapBooster && !isTrueEnergy) {
  // //   setBasePoints(10);
  // // }
  // if (IsTapBooster){
  //   setBasePoints(5*2)
  // }
  // else {
  //   setBasePoints(5)
  // }
  // }, [IsTapBooster]);

  const tapTimestamps = useRef([]);
  const tapBotThreshold = 50; // Number of taps to check for bot detection

  const handleTap = (e) => {
    const currentTime = Date.now();

    // Store the timestamp of the tap
    if (tapTimestamps.current.length >= tapBotThreshold) {
      tapTimestamps.current.shift(); // Remove the oldest tap
    }
    tapTimestamps.current.push(currentTime);

    // Check for bot-like behavior
    if (tapTimestamps.current.length >= tapBotThreshold) {
      const intervals = tapTimestamps.current
        .slice(1)
        .map((time, index) => time - tapTimestamps.current[index]);

      const medianInterval = intervals.sort((a, b) => a - b)[
        Math.floor(intervals.length / 2)
      ];

      // Allow variation based on the median interval (10% threshold)
      const dynamicVariation = Math.max(20, medianInterval * 0.1);

      const isBot = intervals.every(
        (interval) => Math.abs(interval - medianInterval) <= dynamicVariation
      );

      if (isBot) {
        Swal.fire({
          title: "BOT DETECTED!",
          text: "Repetitive tapping pattern found.",
          icon: "warning",
          allowOutsideClick: false, // Prevents closing by clicking outside
          allowEscapeKey: false, // Prevents closing with Esc key
          showConfirmButton: false,
          showCloseButton: true, // Ensures "OK" button is shown
        }).then(() => {
          // Reset timestamps after user clicks "OK"
          tapTimestamps.current = [];
        });
        return;
      }
    }

    if (selectedOption.section === "womensday") {
      const newTapPoints = isAnimationTime.current + 500;
      setAnimaeTap(newTapPoints);
      isAnimationTime.current = newTapPoints;

      if (resetTimeout.current) {
        clearTimeout(resetTimeout.current);
      }
      resetTimeout.current = setTimeout(() => {
        setAnimaeTap(0);
        isAnimationTime.current = 0;
      }, 1000);
    }
    if (energy.current <= 5) return;
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }

    if (tapTimeoutRef.current) {
      clearTimeout(tapTimeoutRef.current);
    }

    setIsTapping(false);
    requestAnimationFrame(() => {
      setIsTapping(true);
      tapTimeoutRef.current = setTimeout(() => {
        setIsTapping(false);
        tapTimeoutRef.current = null;
      }, 3000);
    });

    if (IsPointsReached) {
      setBasePoints(0);
    } else if (IsTapBooster) {
      setBasePoints(getTokenPerTap() * 2);
    } else {
      setBasePoints(getTokenPerTap());
    }

    const touches = e.touches
      ? Array.from(e.touches)
      : [{ clientX: e.clientX, clientY: e.clientY }];

    if (energyy > 0) {
      const totalPoints = Math.min(energyy, basePoints);

      // Update energy
      if (!watchScreen?.booster) {
        setTapPoints((prevTapPoints) => {
          const newTapPoints = prevTapPoints + totalPoints;
          tapPointsRef.current = newTapPoints;
          return newTapPoints;
        });
      }
      if (watchScreen?.booster && !IsPointsReached) {
        setBoosterPoints((prevBoosterPoints) => {
          const newBoosterPoints = prevBoosterPoints + basePoints;
          boosterPointsRef.current = newBoosterPoints;
          return newBoosterPoints;
        });
        setAccumulatedPoints((prevAccumulated) => {
          const newTotal = prevAccumulated + basePoints;
          localStorage.setItem(`accumulatedBoosterPoints_${userId}`, newTotal); // Save accumulated points to localStorage
          return newTotal;
        });
        if (
          latestUserDetails.current.currentComponentText == "TVPage" &&
          watchScreen?.booster
        ) {
          setIsCounterActive((prevState) => !prevState);
        }
      }

      if (!IsTapBooster && !isTrueEnergy && !IsPointsReached) {
        SetEnergy((prevEnergy) => {
          const newEnergy = prevEnergy - totalPoints;
          energy.current = newEnergy;
          localStorage.setItem(
            `energyDetails_${userId}`,
            JSON.stringify({
              energy: newEnergy,
              date: new Date(),
            })
          );
          return newEnergy;
        });
      }
    }
    // Optional animation handling (uncomment if needed)
    const newAnimations = touches.map((touch) => ({
      id: Date.now() + Math.random(),
      x: touch.clientX,
      y: touch.clientY,
    }));
    setTapAnimations((prev) => [...prev, ...newAnimations]);
    playSound();
    setTimeout(() => {
      setTapAnimations((prev) =>
        prev.filter((animation) => !newAnimations.includes(animation))
      );
    }, 1000);
  };
  // const handleTap = debounce((e) => {
  //   if (energy.current > 5) {
  //     if (navigator.vibrate) {
  //       navigator.vibrate(100);
  //     }

  //     const isTouchEvent = e.type === "touchstart";
  //     if (isTouchEvent) {
  //       setLastInputWasTouch(true);
  //     } else if (lastInputWasTouch && !isTouchEvent) {
  //       return; // Ignore mouse event if the last input was touch
  //     }

  //     tapSound.play();

  //     const touches = e.touches
  //       ? Array.from(e.touches)
  //       : [{ clientX: e.clientX, clientY: e.clientY }];
  //     // let num = 5;

  //     // if (watchScreen?.boosterDetails?.name === "tap" && watchScreen?.booster) {
  //     //   num = 10;
  //     //   setBoosterPoints((prevBoosterPoints) => {
  //     //     const newBoosterPoints = prevBoosterPoints + num * touches.length;
  //     //     boosterPointsRef.current = newBoosterPoints;
  //     //     return newBoosterPoints;
  //     //   });
  //     // } else {
  //     //   if (energyy > 0) {
  //     //     const totalPoints = Math.min(energyy, num * touches.length);
  //     //     setTapPoints((prevTapPoints) => {
  //     //       const newTapPoints = prevTapPoints + totalPoints;
  //     //       tapPointsRef.current = newTapPoints;
  //     //       return newTapPoints;
  //     //     });
  //     //     SetEnergy((prev) => {
  //     //       const newEnergy = prev - totalPoints;
  //     //       energy.current = newEnergy;
  //     //       return newEnergy;
  //     //     });
  //     //   }
  //     // }

  //     const newAnimations = touches.map((touch) => ({
  //       id: Date.now() + Math.random(),
  //       x: touch.clientX,
  //       y: touch.clientY,
  //     }));

  //     setTapAnimations((prev) => [...prev, ...newAnimations]);

  //     setTimeout(() => {
  //       setTapAnimations((prev) =>
  //         prev.filter((animation) => !newAnimations.includes(animation))
  //       );
  //     }, 1000);
  //   }
  // });

  const CloseTutorial = async () => {
    const data = {
      tutorialStatus: true,
    };
    // const response = await TutorialUpdate(data);
    updateUserInfo((prev) => ({
      ...prev,
      isTutorial: false,
    }));
    updatewatchScreenInfo((prev) => ({
      ...prev,
      tutorialStatus: true,
    }));

    localStorage.setItem(
      `tutorial_${userId}`,
      JSON.stringify({
        watched: true,
      })
    );
    localStorage.setItem(`TutorialIcon_${userId}`, true);
  };
  const WatchSec = watchScreen?.booster ? getCounter : secsRef.current;
  const TapPoints = !watchScreen?.booster ? tapPoints : 0;

  const TotalScoreNum =
    watchScreen.totalReward + secsRef.current + tapPoints + boosterPoints;

  const TotalScore = Math.floor(TotalScoreNum);
  const FindLengthOfTotalPoints = TotalScore?.toString()?.length;

  let updatedLevel;

  switch (watchScreen?.boosterDetails?.name) {
    case "levelUp":
      updatedLevel = currentLevel + 1;
      break;

    case "2x":
      updatedLevel = currentLevel * 2;
      break;

    case "3x":
      updatedLevel = currentLevel * 3;
      break;

    case "5x":
      updatedLevel = currentLevel * 5;
      break;

    default:
      updatedLevel = currentLevel;
      break;
  }
  const FindPromoDate = process.env.REACT_APP_PROMO_FINAL_DATE;
  const [isPromo, setIsPromo] = useState(false);
  const FindEnergyFinalDate = process.env.REACT_APP_ENERGY_END;
  // const [isEnergyDate, setIsEnergyDate] = useState(false);
  const isEnergyDate = props?.isEnergyDate;
  const setIsEnergyDate = props?.setIsEnergyDate;

  useEffect(() => {
    // Define the target date
    const targetDate = new Date(FindPromoDate);
    const targetEnergyDate = new Date(FindEnergyFinalDate);
    const currentDate = new Date();

    // Check local storage for saved promo state and timestamp
    const savedPromoState = localStorage.getItem(`isPromo_${userId}`);
    const savedTimestamp = localStorage.getItem(`promoTimestamp_${userId}`);

    const savedEnergyState = localStorage.getItem(`isEnergyPopup_${userId}`);
    const savedTimeStampEnergy = localStorage.getItem(
      `energyTimestamp_${userId}`
    );

    if (currentDate > targetDate) {
      // If the current date is past the target date, promo should be false
      setIsPromo(false);
      localStorage.setItem(`isPromo_${userId}`, "false");
    } else if (
      savedPromoState === "false" &&
      savedTimestamp === currentDate.toISOString().split("T")[0]
    ) {
      // If the promo was closed today, keep it closed
      setIsPromo(false);
    } else {
      // Otherwise, reset promo state for a new day
      setIsPromo(true);
      localStorage.setItem(
        `promoTimestamp_${userId}`,
        currentDate.toISOString().split("T")[0]
      );
    }

    if (currentDate > targetEnergyDate) {
      // If the current date is past the target date, promo should be false
      setIsEnergyDate(false);
      localStorage.setItem(`isEnergyPopup_${userId}`, "false");
    } else if (
      savedEnergyState === "false" &&
      savedTimeStampEnergy === currentDate.toISOString().split("T")[0]
    ) {
      // If the promo was closed today, keep it closed
      setIsEnergyDate(false);
    } else {
      // Otherwise, reset promo state for a new day
      setIsEnergyDate(true);
      localStorage.setItem(
        `energyTimestamp_${userId}`,
        currentDate.toISOString().split("T")[0]
      );
    }
  }, []);

  const IsPromoClose = () => {
    setIsPromo(false);
    const currentDate = new Date().toISOString().split("T")[0]; // Today's date
    localStorage.setItem(`isPromo_${userId}`, "false");
    localStorage.setItem(`promoTimestamp_${userId}`, currentDate);
  };
  const IsEnergyPopupClose = () => {
    setIsEnergyDate(false);
    const currentDate = new Date().toISOString().split("T")[0]; // Today's date
    localStorage.setItem(`isEnergyPopup_${userId}`, "false");
    localStorage.setItem(`energyTimestamp_${userId}`, currentDate);
  };
  var PayLoadForNavigate = {
    userWatchSeconds: WatchSecPoint + 1,
    boosterPoints: String(tapPointsRef.current + boosterPointsRef.current),
  };

  const CloseBooster = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    apiCalled.current = true; // Mark as called
    
    // Calculate booster points correctly based on user type
    let boosterPointsToSend;
    if (GetPointDetails?.booster[0] == "tap") {
      // For tap booster, send the accumulated booster points directly
      boosterPointsToSend = String(GetPointDetails?.boosterPoints);
    } else {
      // For other boosters, calculate based on user type
      if (isEarlyUserForWatchMinting) {
        // Early users: subtract 1 point per second instead of level-based points
        boosterPointsToSend = String(GetPointDetails?.boosterPoints - WatchSecPoint * 1);
      } else {
        // Regular users: subtract level-based points per second
        boosterPointsToSend = String(GetPointDetails?.boosterPoints - WatchSecPoint * FindLevel);
      }
    }
    
    const data = {
      userWatchSeconds: WatchSecPoint + 1,
      boosterPoints: boosterPointsToSend,
      boosters: [
        {
          type: watchScreen?.boosterDetails?.name,
          count: watchScreen?.boosterDetails?.count,
        },
      ],
    };

    // Call the API
    addWatchSecapi(data).finally(() => {
      apiCalled.current = false; // Reset after API call completion
    });
  };
  const IsTutorialPage = JSON.parse(
    localStorage.getItem(`tutorialStatus_${userId}`)
  );
  const currentSlide = props?.currentSlide;

  const Slides = TutorialSlides;
  // useEffect(() => {
  //   const handlePress = () => setIsTapped(true);
  //   const handleRelease = () => setIsTapped(false);

  //   // Add event listeners
  //   document.addEventListener("mousedown", handlePress);
  //   document.addEventListener("mouseup", handleRelease);
  //   document.addEventListener("touchstart", handlePress);
  //   document.addEventListener("touchend", handleRelease);

  //   return () => {
  //     // Cleanup event listeners
  //     document.removeEventListener("mousedown", handlePress);
  //     document.removeEventListener("mouseup", handleRelease);
  //     document.removeEventListener("touchstart", handlePress);
  //     document.removeEventListener("touchend", handleRelease);
  //   };
  // }, []);

  const audioRef = useRef(null);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (audioRef.current) {
        if (document.visibilityState === "hidden") {
          console.log("App minimized. Stopping audio.");
          audioRef.current.pause();
        } else if (document.visibilityState === "visible") {
          console.log("App restored. Resuming audio.");
          audioRef.current.play().catch((error) => {
            console.error("Error resuming audio:", error);
          });
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (tapTimeoutRef.current) {
        clearTimeout(tapTimeoutRef.current);
      }
    };
  }, []);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  // const bgwomens = isAnimating && isAnimaeTap > 0? WomenTapBg: "https://d1ccopf5cw1hft.cloudfront.net/s3data/blank1.png";
  //  const WomenTapBg =  "https://d1ccopf5cw1hft.cloudfront.net/s3data/blank1.png";
  const [showText, setShowText] = useState(true);

  useEffect(() => {
    const showAndHideText = () => {
      setShowText(true); // Show the text

      setTimeout(() => {
        setShowText(false); // Hide after 5 seconds
      }, 5000); // 5 seconds
    };

    showAndHideText(); // Show text when the page loads

    const interval = setInterval(() => {
      showAndHideText(); // Repeat every 30 seconds
    }, 30000); // 30 seconds interval

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Add this near other useRef declarations at the top
  const splashImageRef = useRef(null);

  // Add this in the useEffect section where other refs are initialized
  useEffect(() => {
    // Initialize splash image ref
    const img = new Image();
    img.src = spalsh; // Your splash image URL
    splashImageRef.current = img;
  }, []); // Empty dependency array means this runs once on mount
  const fetchMatchList = async () => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const result = await IplMatchData(watchScreen?.cricketLeague);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (result) {
      // setMatchList(result);
      return result; // :white_check_mark: Return result to be used in handleGoToIpl
    } else {
      console.log("Error in MatchScheduleList API");
      return null;
    }
  };
  const fetchBoosterList = async () => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const result = await GetIplBoosterList(userDetails?.userDetails?.telegramId);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (result) {
      // setMatchList(result);
      return result; // :white_check_mark: Return result to be used in handleGoToIpl
    } else {
      console.log("Error in MatchScheduleList API");
      return null;
    }
  };
  const handleGoToIpl = async () => {
    const response = await fetchMatchList(); // :white_check_mark: Wait for updated data
    const BoosterData = await fetchBoosterList();
    if (!response) return; // Handle API error case
    if (response) {
     
    }
    if (BoosterData){
      updatewatchScreenInfo((prev) => ({
        ...prev,
        ipl_booster_list :BoosterData?.boosters,
      }));
      updateUserInfo((prev) => ({
        ...prev,
        ipl_booster_list_static:BoosterData?.boosters,
      }));
     
    }
    if (response.playStarted) {
      goToThePage(Iplwar, "Iplwar");
    } else if (!response.chosenTeam?.[0]?.status) {
      goToThePage(ChooseIplTeam, "ChooseIplTeam");
    } else if (response?.current_battle?.length == 0) {
      goToThePage(MatchScheduleList, "MatchScheduleList");
    } else if (!response.playStarted) {
      goToThePage(MatchScheduleList, "MatchScheduleList");
    } else if (response.playStarted) {
      goToThePage(Iplwar, "Iplwar");
    }
  };
  
  const handleGoToLeagueSelection = () => {
    goToThePage(LeagueSelection, "LeagueSelection");
  }
  return (
    <>
      {!IsTutorialPage ? (
        <TutorialPage currentSlide={currentSlide} />
      ) : !isPromo && !isEnergyDate && !Is5million && !IsPointsTable ? (
        <div className="menupointer" style={{ height: "100%", width: "100%" }}>
          {/* <audio ref={audioRef} src={beatAudio} autoPlay loop /> */}
          {/* <audio
            ref={audioRef}
            src={beatAudio} // Replace with your audio file path
          /> */}
          {!IsTutorial ? (
            <div
              className="tutorial"
              style={{
                height: "100%",
                width: "100%",
                position: "absolute",
                zIndex: 2,
                backgroundColor: "transparent",
              }}
            >
              <div
                className="row level-div text-center"
                style={{
                  margin: "55px 35px",
                }}
              >
                <div className="col-6">
                  <div className="level-h2" style={{ position: "relative" }}>
                    <h2 className="level" style={{ visibility: "hidden" }}>
                      Level {currentLevel} &nbsp;
                      {formatNumber(TotalScore)}
                      {currentLevel == 10 ? "" : "/"}
                      {formatNumber(level[currentLevel + 1])}
                    </h2>
                    <h2
                      className="level"
                      style={{
                        position: "absolute",
                        top: -30,
                        left: 0,
                        opacity: 1,
                        zIndex: 1000000,
                      }}
                    >
                      <div
                        className="loader"
                        onClick={() => {
                          playClick();
                          updateUserInfo((prev) => ({
                            ...prev,
                            tutorialText:
                              "TRACK YOUR CURRENT LEVEL AND LEADERBOARD",
                          }));
                        }}
                      >
                        <div className="dot"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                      </div>
                    </h2>
                    <div
                      style={{
                        height: "10px",
                        marginBottom: "10px",
                        visibility: "hidden",
                      }}
                    >
                      <ProgressBar style={{ height: "10px" }}>
                        <ProgressBar
                          variant="warning"
                          now={Number(
                            ((watchScreen.totalReward +
                              secs +
                              tapPoints +
                              Number(boosterPoints)) /
                              level[currentLevel + 1]) *
                              100
                          ).toFixed()}
                          key={1}
                        />
                      </ProgressBar>

                      {/* <DashedProgressBar
                    progress={Number(
                      ((watchScreen.totalReward +
                        secs +
                        tapPoints +
                        Number(boosterPoints)) /
                        level[currentLevel + 1]) *
                        100
                    ).toFixed()}
                  /> */}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="level-h2">
                    <h2
                      className="level"
                      style={{
                        position: "absolute",
                        top: 30,
                        opacity: 1,
                        zIndex: 1000000,
                      }}
                    >
                      <div
                        className="loader"
                        onClick={() => {
                          playClick();
                          updateUserInfo((prev) => ({
                            ...prev,
                            tutorialText: "TRACK ENERGY BAR DROP PER TAP",
                          }));
                        }}
                      >
                        <div className="dot"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                      </div>
                    </h2>
                    <div className="displex">
                      <h2 className="energy" style={{ visibility: "hidden" }}>
                        <img src={engimg} style={{ paddingRight: "3px" }} />
                        ENERGY {!isTrueEnergy && `${energy.current}/5000`}
                      </h2>
                      {isTrueEnergy && (
                        <img
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/infinity.svg"
                          style={{ width: "25px", height: "16px" }}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        height: "10px",
                        marginBottom: "10px",
                        visibility: "hidden",
                      }}
                    >
                      <ProgressBar style={{ height: "10px" }}>
                        <ProgressBar
                          now={(energy.current / 5000) * 100}
                          key={1}
                        />
                      </ProgressBar>
                    </div>
                  </div>
                </div>

                <div className="row streak-center">
                  <div
                    onClick={() => {}}
                    className="col-2 text-center"
                    style={{ position: "relative" }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/help.svg"
                      alt="Help"
                      style={{ visibility: "hidden" }}
                    />
                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText: "ABOUT THEMEMETV - HOW IT WORKS",
                        }));
                      }}
                      style={{ position: "absolute", top: -25, left: -10 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>

                  <div className="col-8 ">
                    <div className="row text-center phase1">
                      <div className="col-5" style={{ position: "relative" }}>
                        <h2 className="streak" style={{ visibility: "hidden" }}>
                          STREAK <FaChevronRight style={{ fontSize: "12px" }} />
                        </h2>
                        <div
                          className="loader"
                          onClick={() => {
                            playClick();
                            updateUserInfo((prev) => ({
                              ...prev,
                              tutorialText:
                                "MONITOR TASKS CONTRIBUTING TO YOUR STREAK",
                            }));
                          }}
                          style={{ position: "absolute", top: -30 }}
                        >
                          <div className="dot"></div>
                          <div className="circle"></div>
                          <div className="circle"></div>
                          <div className="circle"></div>
                        </div>
                      </div>
                      <div
                        className="col-2 phase-p"
                        style={{ position: "relative", visibility: "hidden" }}
                      >
                        {/* <h6>p</h6> */}
                        {/* <div
                          className="loader"
                          onClick={() => {
                            playClick();
                            updateUserInfo((prev) => ({
                              ...prev,
                              tutorialText: "YOUR CURRENT PHASE",
                            }));
                          }}
                          style={{
                            position: "absolute",
                            top: -25,
                            left: -20,
                            visibility: "visible",
                          }}
                        >
                          <div className="dot"></div>
                          <div className="circle"></div>
                          <div className="circle"></div>
                          <div className="circle"></div>
                        </div> */}
                      </div>

                      <div className="col-5" style={{ position: "relative" }}>
                        <h2 className="streak" style={{ visibility: "hidden" }}>
                          {" "}
                          STAKE <FaChevronRight
                            style={{ fontSize: "12px" }}
                          />{" "}
                        </h2>
                        <div
                          className="loader"
                          onClick={() => {
                            playClick();
                            updateUserInfo((prev) => ({
                              ...prev,
                              tutorialText:
                                "STAKE YOUR TOKENS TO DOUBLE YOUR REWARDS",
                            }));
                          }}
                          style={{
                            position: "absolute",
                            top: -30,
                            visibility: "visible",
                          }}
                        >
                          <div className="dot"></div>
                          <div className="circle"></div>
                          <div className="circle"></div>
                          <div className="circle"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-2 text-center"
                    style={{ position: "relative" }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/wallet.svg"
                      alt="ConnectWallet"
                      className="wallet-image"
                      style={{ visibility: "hidden" }}
                    />
                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText: "CONNECT WALLET AND AIRDROP TASKS",
                        }));
                      }}
                      style={{ position: "absolute", top: -30, left: -10 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-2" style={{ position: "relative" }}>
                    <div className="token-div" style={{ visibility: "hidden" }}>
                      <p className="token-mint">POINT MINTING</p>
                      <p className="earn-p">
                        {IsPointsReached
                          ? 0
                          : isEarlyUserForWatchMinting
                          ? 1
                          : updatedLevel}
                        /Sec
                      </p>
                    </div>
                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText: "TOKENS EARNED PER SECOND",
                        }));
                      }}
                      style={{ position: "absolute", top: -10, left: -10 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>
                  <div className="col-8 " style={{ position: "relative" }}>
                    <h2 style={{ visibility: "hidden" }}>
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg"
                        alt="Meme TV"
                      />
                      <span className="txt-color ml-5">{TotalScore}</span>
                    </h2>

                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText: "CHECK YOUR TOTAL EARNED TOKENS",
                        }));
                      }}
                      style={{ position: "absolute", top: -10, left: 65 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>
                  <div className="col-2" style={{ position: "relative" }}>
                    <div className="token-div" style={{ visibility: "hidden" }}>
                      <p className="token-mint1">Earn / tap</p>
                      <p className="earn-p">
                        {IsPointsReached ? 0 : IsTapBooster ? 5 * 2 : 5}
                      </p>
                    </div>
                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText: "TOKENS EARNED PER TAP",
                        }));
                      }}
                      style={{ position: "absolute", top: -20, left: -10 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>
                </div>
                <div className="row streak-center" style={{ marginTop: "5px" }}>
                  <div
                    className="col-2 text-center"
                    style={{ position: "relative" }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/invitetv.svg"
                      alt="Settings"
                      style={{ visibility: "hidden" }}
                    />
                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText:
                            "REFER AND EARN - VIEW YOUR REFERRALS AND REFERRAL MILESTONES",
                        }));
                      }}
                      style={{ position: "absolute", top: -20, left: -10 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>

                  <div className="col-8 text-c">
                    <div className="">
                      <div className="col-9">
                        {watchScreen.booster ? (
                          <>
                            <h2
                              className="streak booster"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                visibility: "hidden",
                              }}
                            >
                              <img
                                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/clock.svg"
                                style={{ paddingRight: "5px", width: "20px" }}
                              />
                              {watchScreen.boosterSec}
                            </h2>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-2 text-center"
                    style={{ position: "relative" }}
                  >
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/leaderboard.svg"
                      alt="Help"
                      style={{ visibility: "hidden" }}
                    />
                    <div
                      className="loader"
                      onClick={() => {
                        playClick();
                        updateUserInfo((prev) => ({
                          ...prev,
                          tutorialText: "DO TASKS AND EARN TOKENS",
                        }));
                      }}
                      style={{ position: "absolute", top: -20, left: -10 }}
                    >
                      <div className="dot"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </div>
                </div>
                <p style={{ color: "white" }}>
                  {userDetails?.tutorialText ? userDetails?.tutorialText : null}
                </p>
              </div>

              <img
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                // className="cancel-img"
                onClick={() => {
                  // closePopUp();
                  // setIsTutorial(false);

                  // setIsTutorial(false);
                  CloseTutorial();
                  playClick();
                }}
                style={{
                  position: "absolute",
                  width: "10%",
                  left: "45%",
                  top: "80%",
                }}
              />
              {/* <div
            className="row"
            style={{ height: "500px" }}
            onTouchStart={handleTap}
            onMouseDown={handleTap}
          >
            <div
              className="col-12"
              style={{
                zIndex: "-1",
              }}
            >
              <div className="floor"></div>
              <img
                src={karathe}
                className="woot-dance"
                width="328"
                height="272"
                alt="8-bit dancing Karateka guy"
              />
              {tapAnimations.map((animation) => (
                <div
                  key={animation.id}
                  className="tap-points txt-color"
                  style={{
                    left: animation.x,
                    top: animation.y,
                    visibility: "none",
                  }}
                >
                  +{watchScreen.boosterDetails.name === "tap" ? 10 : 5}
                </div>
              ))}
            </div>
          </div> */}
            </div>
          ) : null}
          {isLoading && (
            <div className="loaderstyle">
              <div className="spinner"></div>
            </div>
          )}
          <div className="line arrow"></div>
          <div
            className="row level-div text-center"
            style={{
              margin: "14% 8% 0%",
            }}
          >
            <div
              className="col-6"
              style={
                {
                  // filter: watchScreen?.booster ? "grayscale(1)" : "none",
                }
              }
            >
              <div className="level-h2">
                <h2
                  onClick={() => {
                    playClick();
                    if (!watchScreen.booster) {
                      var data = {
                        userWatchSeconds: WatchSecPoint + 1,
                        boosterPoints: String(boosterPointsRef.current),
                        tapPoints: String(tapPointsRef.current),
                      };
                      addWatchSecapiStreak(data, "Leader");
                    } else {
                      handleClick();

                      //  goToThePage(LeaderBoard, "LeaderBoard");
                    }
                  }}
                  className="level"
                >
                  LEVEL {currentLevel} &nbsp;
                  {formatNumber(TotalScore)}
                  {currentLevel == 10 ? "" : "/"}
                  {formatNumber(level[currentLevel + 1])}
                </h2>

                <div style={{ height: "10px", marginBottom: "10px" }}>
                  {/* <ProgressBar style={{ height: "10px" }}>
                <ProgressBar
                  variant="warning"
                  now={Number(
                    ((watchScreen.totalReward +
                      secs +
                      tapPoints +
                      Number(boosterPoints)) /
                      level[currentLevel + 1]) *
                      100
                  ).toFixed()}
                  key={1}
                />
              </ProgressBar> */}

                  <DashedProgressBar
                    dashcolor={"#E1CA00"}
                    lengthColor={"#E1CA00"}
                    progress={
                      currentLevel == 10
                        ? 100
                        : Number(
                            ((watchScreen.totalReward +
                              secs +
                              tapPoints +
                              Number(boosterPoints)) /
                              level[currentLevel + 1]) *
                              100
                          ).toFixed()
                    }
                  />
                </div>
              </div>
            </div>
            <div
              className="col-6"
              style={
                {
                  // filter: watchScreen?.booster ? "grayscale(1)" : "none",
                }
              }
            >
              <div className="level-h2">
                {/* <h2 className="energy">
                  <img src={engimg} style={{ paddingRight: "3px" }} />
                  ENERGY  {energy.current}/5000
                </h2> */}
                <div className="displex">
                  <h2 className="energy">
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/energy.svg"
                      style={{ paddingRight: "3px" }}
                    />
                    ENERGY {!isTrueEnergy && `${energy.current}/5000`}
                  </h2>
                  {isTrueEnergy && (
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/infinity.svg"
                      style={{ width: "25px", height: "16px" }}
                    />
                  )}
                </div>
                <div style={{ height: "10px", marginBottom: "10px" }}>
                  {/* <ProgressBar style={{ height: "10px" }}>
                <ProgressBar now={(energy.current / 5000) * 100} key={1} />
              </ProgressBar> */}

                  <DashedProgressBar
                    dashcolor={"#00AEEF"}
                    lengthColor={"#33c6f6"}
                    progress={(energy.current / 5000) * 100}
                  />
                </div>
              </div>
            </div>
            <div className="row streak-center">
              <div
                onClick={() => {
                  if (!watchScreen.booster) {
                    playClick();
                    var data = {
                      userWatchSeconds: WatchSecPoint + 1,
                      boosterPoints: String(boosterPointsRef.current),
                      tapPoints: String(tapPointsRef.current),
                    };
                    addWatchSecapihelp(data);
                  }
                }}
                className="col-2 text-center"
                style={{
                  opacity: watchScreen?.booster ? 0.5 : 1,
                  filter: watchScreen?.booster ? "grayscale(1)" : "none",
                }}
              >
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/help-y.svg"
                  alt="Help"
                />
              </div>
              <div className="col-8 streak-border">
                <div className="row text-center phase1">
                  <div className="col-6 stk">
                    <h2
                      onClick={() => {
                        if (!watchScreen.booster && !IsPointsReached) {
                          // updateUserInfo((prev) => ({
                          //   ...prev,
                          //   isLoading: true,
                          // }));
                          var data = {
                            userWatchSeconds: WatchSecPoint + 1,
                            boosterPoints: String(boosterPointsRef.current),
                            tapPoints: String(tapPointsRef.current),
                          };
                          addWatchSecapiStreak(data);
                        } else {
                          handleClick();

                          // goToThePage(Streak, "Streak");
                        }
                      }}
                      className="streak"
                      style={{
                        opacity:
                          watchScreen?.booster || IsPointsReached ? 0.5 : 1,
                      }}
                    >
                      {" "}
                      STREAK <FaChevronRight style={{ fontSize: "12px" }} />
                    </h2>
                  </div>
                  {/* <div className="col-2 phase-p">
                    P{userDetails?.currentPhase}
                  </div> */}
                  <div
                    className="col-6"
                    onClick={() => {
                      if (!watchScreen.booster) {
                        var data = {
                          userWatchSeconds: WatchSecPoint + 1,
                          boosterPoints: String(boosterPointsRef.current),
                          tapPoints: String(tapPointsRef.current),
                        };
                        addWatchSecapiStake(data);
                      } else {
                        handleClick();

                        // goToThePage(Phase, "Phase");
                      }
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        zIndex: "-1",
                      }}
                    >
                      {/* Only show loader when not fully staked AND staked days haven't crossed */}
                      {!userDetails?.isFullyStaked &&
                        !userDetails?.isStakedDaysCrossed && (
                          <div className="loaderstk">
                            <div className="dotstk"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                          </div>
                        )}
                    </div>

                    <h2
                      className="streak"
                      style={{ opacity: watchScreen?.booster ? 0.5 : 1 }}
                    >
                      STAKE <FaChevronRight style={{ fontSize: "12px" }} />
                    </h2>
                  </div>
                </div>
              </div>

              <div
                onClick={() => {
                  if (!watchScreen.booster) {
                    var data = {
                      userWatchSeconds: WatchSecPoint + 1,
                      boosterPoints: String(boosterPointsRef.current),
                      tapPoints: String(tapPointsRef.current),
                    };
                    addWatchSecapiwallet(data);
                  } else {
                    handleClick();

                    goToThePage(ConnectWallet, "ConnectWallet");
                  }
                }}
                className="col-2 text-center"
                style={{
                  opacity: watchScreen?.booster ? 0.5 : 1,
                  filter: watchScreen?.booster ? "grayscale(1)" : "none",
                }}
              >
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/wallet.svg"
                  alt="ConnectWallet"
                  className="wallet-image"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-2">
                <div
                  className="token-div"
                  style={
                    {
                      // filter: watchScreen?.booster ? "grayscale(1)" : "none",
                    }
                  }
                >
                  <p className="token-mint">TOKEN MINT</p>
                  <p className="earn-p">
                    <span
                      style={{
                        fontSize:
                          watchScreen?.boosterDetails?.name === "levelUp" &&
                          currentLevel + 1 > 9
                            ? "16px"
                            : "14px",
                      }}
                    >
                      {IsPointsReached
                        ? 0
                        : isEarlyUserForWatchMinting&& !watchScreen.booster
                        ? 1:
                        isEarlyUserForWatchMinting&& watchScreen.booster?
                        BoosterPerSec
                        : updatedLevel}
                    </span>
                    <span style={{ fontSize: "12px" }}>/Sec</span>
                  </p>
                </div>
              </div>
              <div
                className="col-8 points"
                onClick={() => {
                  if (!watchScreen.booster) {
                    const values = JSON.parse(
                      localStorage.getItem(`pointDetails_${userId}`)
                    );
                    var data = {
                      userWatchSeconds: values.watchSec + 1,
                      tapPoints: String(values.tapPoints),
                    };
                    // var data = {
                    //   userWatchSeconds: secsRef.current,
                    //   boosterPoints: String(
                    //     tapPointsRef.current + boosterPointsRef.current
                    //   ),
                    // };
                    addWatchSecapiTotal(data);
                  } else {
                    handleClick();

                    // goToThePage(TotalPoints, "TotalPoints");
                  }
                }}
              >
                <div
                  className={`${watchScreen.booster ? "rotateb" : "rotate"}`}
                >
                  {/* <div class="container1"> */}
                  {/* <div class="fixed-center"></div> */}
                </div>
                <h2>
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg"
                    alt="Meme TV"
                    style={{
                      width: FindLengthOfTotalPoints >= 9 ? "25px" : "30px",
                    }}
                  />

                  <span
                    className="txt-color ml-5"
                    style={{
                      fontSize: FindLengthOfTotalPoints >= 9 ? "14px" : "20px",
                    }}
                  >
                    {TotalScore}
                  </span>
                </h2>
              </div>
              <div className="col-2">
                <div
                  className="token-div"
                  style={
                    {
                      // filter: watchScreen?.booster ? "grayscale(1)" : "none",
                    }
                  }
                >
                  <p className="token-mint1">EARN / TAP</p>
                  <p className="earn-p">
                    {IsPointsReached
                      ? 0
                      : IsTapBooster
                      ? getTokenPerTap() * 2
                      : getTokenPerTap()}
                  </p>
                </div>
              </div>
              <div
                className="row streak-center booster-head position-relative"
                style={{
                  marginTop: "6px",
                  display: "-webkit-box",
                  zIndex: "1",
                }}
              >
                <div
                  className="col-2 text-center audioflex"
                  style={{
                    opacity: watchScreen?.booster ? 0.5 : 1,
                    filter: watchScreen?.booster ? "grayscale(1)" : "none",
                  }}
                >
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/invitetv.svg"
                    alt="Settings"
                    onClick={() => {
                      if (!watchScreen.booster) {
                        var data = {
                          userWatchSeconds: WatchSecPoint + 1,
                          boosterPoints: String(boosterPointsRef.current),
                          tapPoints: String(tapPointsRef.current),
                        };

                        addWatchSecapirefer(data);
                      } else {
                        handleClick();
                        // if(IsTutorial){
                        // goToTheRefererPage(ReferPage, "ReferPage");
                        // }
                      }
                    }}
                  />
                  <div
                    className="img-audio d-flex justify-content-center"
                    onClick={toggleMute}
                    style={{
                      paddingTop: "5px",
                      // opacity: watchScreen?.booster ? 0.5 : 1,

                      // filter: watchScreen?.booster ? "grayscale(1)" : "none",
                    }}
                  >
                    <img
                      src={isMuted ? muteIcon : unmuteIcon}
                      alt={isMuted ? "Muted Audio" : "Unmuted Audio"}
                    />
                  </div>
                </div>
                <div className="col-8">
                  {watchScreen.booster ? (
                    <>
                      <div className="text-c booster">
                        <div className="col-12">
                          <div className="row">
                            <div className="col-4">
                              {/* <H4>80</H4> */}
                              <h4 className="booster-point">
                                {watchScreen.boosterSec}
                              </h4>
                              {/* <img
                          src={clock}
                          style={{ paddingRight: "5px", width: "20px" }}
                        /> */}
                            </div>
                            <div className="col-8">
                              <div className="marquee">
                                <div>
                                  <span className="b-donothing">
                                    {watchScreen?.boosterDetails?.name} Booster
                                    is activated. &nbsp;
                                    {watchScreen?.boosterDetails?.name} Booster
                                    is activated.
                                  </span>
                                </div>
                              </div>
                              <div
                                style={{ zIndex: "-999" }}
                                className="exit-boost"
                                onClick={CloseBooster}
                              >
                                Exit Booster
                              </div>
                            </div>
                          </div>

                          {/*
                        <h2
                          className="streak booster"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={clock}
                            style={{ paddingRight: "5px", width: "20px" }}
                          />
                          {watchScreen.boosterSec}
                        </h2> */}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* <div onClick={handleGoToLeagueSelection}>
                        {" "}
                        <img src={iplLive} style={{ width: "132px" }}></img>
                      </div> */}
                     

                      {/* <div>
                        <button
                          onClick={() =>
                            goToThePage(CollegeForm, "CollegeForm")
                          }
                        >
                          Go to College Form
                        </button>
                      </div> */}
                    </>

                    //   <div onClick={handleGoToIpl} className="dflex" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                    //      <div className="text-lg font-semibold mb-4 text-uppercase spl-start">
                    //      <img src={iplLive} style={{width:"40px",}} /> IS LIVE <i className="fas fa-arrow-right" style={{marginLeft: "5px"}}></i>
                    // </div>
                    //   </div>
                    // selectedOption.section == "Ipl" && <CountdownTimer />
                  )}
                </div>

                {/* <div>
                    GAuth
                  </div> */}
                <div
                  className="col-2 text-center audioflex"
                  style={{
                    opacity: watchScreen?.booster ? 0.5 : 1,
                    filter: watchScreen?.booster ? "grayscale(1)" : "none",
                  }}
                >
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/leaderBoard.svg"
                    alt="Help"
                    onClick={() => {
                      if (!watchScreen.booster) {
                        var data = {
                          userWatchSeconds: WatchSecPoint + 1,
                          boosterPoints: String(boosterPointsRef.current),
                          tapPoints: String(tapPointsRef.current),
                        };

                        addWatchSecapicheap(data);
                      } else {
                        handleClick();

                        // goToThePage(DoandEarn, "DoandEarn");
                      }
                    }}
                  />

                  <div
                    className={`dropdown-tv1 ${isDropdownOpen ? "" : "show"}`}
                    style={{
                      width: "fit-content",
                      background: "#282828",
                      borderRadius: "5px",
                      opacity: watchScreen?.booster ? 0.5 : 1,
                      display: watchScreen?.booster ? "none" : "",
                      filter: watchScreen?.booster ? "grayscale(1)" : "none",
                    }} // Adjusts to the image size
                  >
                    <button
                      style={{
                        width: "fit-content",
                        padding: 0, // Removes extra padding
                        border: "none",
                        background: "transparent", // Makes the button visually clean
                      }}
                      className="btn d-flex align-items-center justify-content-center"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                      onClick={toggleDropdown}
                    >
                      {selectedOption.image && (
                        <img
                          src={selectedOption.image}
                          alt={selectedOption.label}
                          style={{
                            width: "40px",
                            height: "40px",
                            padding: "5px",
                            // borderRadius: "50%", // Optional: Rounds the image
                          }}
                        />
                      )}
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                      style={{
                        minWidth: "fit-content", // Ensures dropdown width matches image size
                        padding: 0,
                        left: "-5px",
                        top: "12px", // Removes padding
                      }}
                    >
                      {options.map((option, index) => (
                        <li key={index}>
                          <button
                            className="dropdown-item"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 0, // Removes padding
                            }}
                            onClick={() => handleOptionClick(option)}
                          >
                            <img
                              src={option.image}
                              alt={option.label}
                              style={{
                                width: "30px",
                                height: "30px",
                                // borderRadius: "50%", // Optional: Matches button style
                              }}
                            />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="row"
                style={{
                  marginTop: selectedOption.section === "Ipl" ? "-15px" : "2px",
                }}
              >
                <div className="col-8 flex">
                  <div
                    className={`holi-text ${
                      showText ? "animate-fadeInScale" : "animate-fadeOutScale"
                    }`}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{
              display: selectedOption.section === "Ipl" ? "block" : "none",
              height: "500px",
            }}
            onTouchStart={handleTap}
            // onMouseDown={handleTap}
            ref={containerRef}
          >
            <div
              className="col-12"
              style={{
                zIndex: "-1",
              }}
            >
              <div
                style={{
                  position: "absolute",
                }}
              >
                {/* {watchScreen.boosterDetails.name === "5x" ? ( */}
                <>
                  <div
                    className="fade-method-3-container"
                    style={{ position: "relative" }}
                  >
                    <div class="fade-method-3-overlay"></div>
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/stadiumgif.gif"
                      className="cricket-dance"
                      width="328"
                      height="272"
                      alt="8-bit dancing Karateka guy"
                    />

                    <div
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        top: 0,
                        left: 0,
                      }}
                    >
                      {/* <img
                    src={mask}
                    className={
                      watchScreen.boosterDetails.name
                        ? "woot-dance booster-mask boosterfilter"
                        : "woot-dance booster-mask"
                    }
                    width="328"
                    height="272"
                    alt="8-bit dancing Karateka guy"
                    style={
                      // watchScreen.boosterDetails.name === "5x"
                      //   ? { visibility: "visible" }
                      //   :
                      { visibility: "hidden" }
                    }
                  /> */}
                    </div>

                    {/* <div
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    top: 0,
                    left: 0,
                  }}
                >
                  <img
                    src={mask}
                    className="woot-dance booster-mask"
                    width="328"
                    height="272"
                    alt="8-bit dancing Karateka guy"
                    style={
                      watchScreen.boosterDetails.name === "5x"
                        ? { visibility: "visible" }
                        : { visibility: "hidden" }
                    }
                  />
                </div> */}
                  </div>
                </>
                {/* ) : (
              <img
                src={karathe}
                className="woot-dance"
                width="328"
                height="272"
                alt="8-bit dancing Karateka guy"
              /> */}
                {/* )} */}
              </div>

              <>
                {tapAnimations.map((animation) => (
                  <div
                    key={animation.id}
                    className="tap-points txt-color"
                    style={{
                      left: animation.x,
                      top: animation.y,
                    }}
                  >
                    {IsPointsReached ? (
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg"
                        alt="Meme TV"
                        style={{ width: "25px" }}
                      />
                    ) : (
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/whiteball.png"
                        alt="Meme TV"
                        style={{ width: "30px" }}
                      />
                    )}
                  </div>
                ))}{" "}
              </>
            </div>
          </div>

          <div
            className="row"
            style={{
              display:
                selectedOption.section === "womensday" ? "block" : "none",
              height: "500px",
            }}
            onTouchStart={handleTap}
            onClick={handleTapStart}
          >
            <div
              className="col-12"
              style={{
                zIndex: "-1",
              }}
            >
              <>
                <div
                  class="image-container"
                  // onTouchStart={handleTapStart}
                  // onTouchEnd={handleTapEnd}
                >
                  {isAnimating && isAnimaeTap > 0 && (
                    <img src={womenForeGround}></img>
                  )}
                  <img
                    src={characker}
                    alt="Character"
                    className={`front-image-cri ${
                      isAnimating ? "animate-full" : ""
                    }`}
                    style={{
                      transition: "opacity 0.3s",
                      opacity: 1,
                      animation: isAnimating
                        ? "playFullGif 1.5s forwards"
                        : "none",
                    }}
                  />
                  <img
                    style={{ bottom: "0px" }}
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/womensdaybgnew.gif"
                    alt="Backside"
                    class="back-image-cri"
                  />
                </div>
              </>

              {tapAnimations.map((animation) => (
                <div
                  key={animation.id}
                  className="tap-points holi-animation txt-color"
                  style={{
                    left: animation.x,
                    top: animation.y,
                  }}
                >
                  {IsPointsReached ? (
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg"
                      alt="Meme TV"
                      style={{ width: "25px" }}
                    />
                  ) : (
                    "+" + basePoints
                  )}
                </div>
              ))}
            </div>
          </div>

          <div
            className="row"
            style={{
              display:
                selectedOption.section === "memetvGuy" ? "block" : "none",
              height: "500px",
            }}
            onTouchStart={handleTap}
            // onMouseDown={handleTap}
          >
            <div style={{ height: "200px", width: "100%" }}>
              <p
                className="boosterText"
                style={{
                  fontSize: "80px",
                  fontFamily: "Press Start 2P",
                  color: "white",
                  position: "absolute",
                  width: "100%",
                  textAlign: "center",
                  zIndex: 1,
                  bottom: "20%",
                  opacity: 0.15,
                }}
              >
                {watchScreen.boosterDetails.name === "2x" ? "2X" : null}
                {watchScreen.boosterDetails.name === "3x" ? "3X" : null}
                {watchScreen.boosterDetails.name === "5x" ? "5X" : null}
                {watchScreen.boosterDetails.name === "levelUp" ? "UP" : null}
                {watchScreen.boosterDetails.name === "tap" ? "TAP" : null}
              </p>
            </div>
            <div
              className="col-12"
              style={{
                zIndex: "-1",
              }}
            >
              <div
                className="floor"
                style={
                  // watchScreen.booster
                  //   ? {
                  //       position: "fixed",
                  //       bottom: "15%",
                  //       width: "100%",
                  //       height: "96px",
                  //       backgroundColor: "#670000",
                  //     }
                  //   :
                  {
                    position: "fixed",
                    bottom: "15%",
                    width: "100%",
                    zIndex: "-1",
                    height: "96px",
                    filter: "blur(2px)",
                    backgroundColor: !watchScreen.booster
                      ? "#2800B8"
                      : watchScreen.boosterDetails.name === "5x"
                      ? "rgb(103 0 0)"
                      : watchScreen.boosterDetails.name === "2x"
                      ? "rgb(0 44 137)"
                      : watchScreen.boosterDetails.name === "3x"
                      ? "#6E00A2"
                      : watchScreen.boosterDetails.name === "levelUp"
                      ? "rgb(0 57 0)"
                      : "rgb(0 57 0)",
                  }
                }
              ></div>
              <div
                style={{
                  position: "absolute",
                }}
              >
                {/* {watchScreen.boosterDetails.name === "5x" ? ( */}
                <>
                  <div style={{ position: "relative" }}>
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/kara1.webp"
                      className={
                        !watchScreen.booster
                          ? "woot-dance"
                          : watchScreen.boosterDetails.name === "5x"
                          ? "woot-dance5x boosterfilter"
                          : watchScreen.boosterDetails.name === "2x"
                          ? "woot-dance2x boosterfilter1"
                          : watchScreen.boosterDetails.name === "3x"
                          ? "woot-dance3x boosterfilter2"
                          : watchScreen.boosterDetails.name === "levelUp"
                          ? "woot-dance boosterfilter3"
                          : "woot-dance boosterfilter4"
                      }
                      width="328"
                      height="272"
                      alt="8-bit dancing Karateka guy"
                    />

                    <div
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        top: 0,
                        left: 0,
                      }}
                    >
                      {/* <img
                    src={mask}
                    className={
                      watchScreen.boosterDetails.name
                        ? "woot-dance booster-mask boosterfilter"
                        : "woot-dance booster-mask"
                    }
                    width="328"
                    height="272"
                    alt="8-bit dancing Karateka guy"
                    style={
                      // watchScreen.boosterDetails.name === "5x"
                      //   ? { visibility: "visible" }
                      //   :
                      { visibility: "hidden" }
                    }
                  /> */}
                    </div>

                    {/* <div
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    top: 0,
                    left: 0,
                  }}
                >
                  <img
                    src={mask}
                    className="woot-dance booster-mask"
                    width="328"
                    height="272"
                    alt="8-bit dancing Karateka guy"
                    style={
                      watchScreen.boosterDetails.name === "5x"
                        ? { visibility: "visible" }
                        : { visibility: "hidden" }
                    }
                  />
                </div> */}
                  </div>
                </>
                {/* ) : (
              <img
                src={karathe}
                className="woot-dance"
                width="328"
                height="272"
                alt="8-bit dancing Karateka guy"
              /> */}
                {/* )} */}
              </div>
              {tapAnimations.map((animation) => (
                <div
                  key={animation.id}
                  className="tap-points txt-color"
                  style={{
                    left: animation.x,
                    top: animation.y,
                  }}
                >
                  {IsPointsReached ? (
                    <img
                      src="https://d1ccopf5cw1hft.cloudfront.net/s3data/meme-logo.svg"
                      alt="Meme TV"
                      style={{ width: "25px" }}
                    />
                  ) : (
                    "+" + basePoints
                  )}
                </div>
              ))}{" "}
            </div>
          </div>
          <div
            className="row"
            style={{
              display:
                selectedOption.section === "shivaratri" ? "block" : "none",
              height: "500px",
            }}
            onTouchStart={handleTap}
            onClick={handleTapStart}
          >
            <div style={{ height: "200px", width: "100%" }}>
              <p
                className="boosterText"
                style={{
                  fontSize: "80px",
                  fontFamily: "Press Start 2P",
                  color: "white",
                  position: "absolute",
                  width: "100%",
                  textAlign: "center",
                  zIndex: 1,
                  bottom: "20%",
                  opacity: 0.15,
                }}
              >
                {/* {watchScreen.boosterDetails.name === "2x" ? "2X" : null}
                {watchScreen.boosterDetails.name === "3x" ? "3X" : null}
                {watchScreen.boosterDetails.name === "5x" ? "5X" : null}
                {watchScreen.boosterDetails.name === "levelUp" ? "UP" : null}
                {watchScreen.boosterDetails.name === "tap" ? "TAP" : null} */}
              </p>
            </div>
            <div
              className="col-12"
              style={{
                zIndex: "-1",
              }}
            >
              <div
                className="floor-shiva"
                style={
                  // watchScreen.booster
                  //   ? {
                  //       position: "fixed",
                  //       bottom: "15%",
                  //       width: "100%",
                  //       height: "96px",
                  //       backgroundColor: "#670000",
                  //     }
                  //   :
                  {
                    opacity: "0.5",
                    position: "fixed",
                    bottom: "15%",
                    zIndex: "-4",
                    width: "100%",
                    // height: "96px",
                    // filter: "blur(2px)",
                    // backgroundColor: !watchScreen.booster
                    //   ? "#2800B8"
                    //   : watchScreen.boosterDetails.name === "5x"
                    //   ? "rgb(103 0 0)"
                    //   : watchScreen.boosterDetails.name === "2x"
                    //   ? "rgb(0 44 137)"
                    //   : watchScreen.boosterDetails.name === "3x"
                    //   ? "#6E00A2"
                    //   : watchScreen.boosterDetails.name === "levelUp"
                    //   ? "rgb(0 57 0)"
                    //   : "rgb(0 57 0)",
                    backgroundImage: !watchScreen.booster
                      ? "url('https://d1ccopf5cw1hft.cloudfront.net/s3data/shiva-bgGif.gif')"
                      : watchScreen.boosterDetails.name === "5x"
                      ? "url('https://d1ccopf5cw1hft.cloudfront.net/s3data/5XX_BG.gif')"
                      : watchScreen.boosterDetails.name === "2x"
                      ? "url('https://d1ccopf5cw1hft.cloudfront.net/s3data/2XX_Gif.gif')"
                      : watchScreen.boosterDetails.name === "3x"
                      ? "url('https://d1ccopf5cw1hft.cloudfront.net/s3data/3XX_Gif.gif')"
                      : watchScreen.boosterDetails.name === "levelUp"
                      ? "url('https://d1ccopf5cw1hft.cloudfront.net/s3data/Booster_Gif.gif')"
                      : "url('https://d1ccopf5cw1hft.cloudfront.net/s3data/Tap_Gif.gif')",
                  }
                }
              ></div>

              {/* {watchScreen.boosterDetails.name === "5x" ? ( */}
              <>
                {/* <div style={{ position: "relative" }}>
                    <img
                      // src="https://res.cloudinary.com/dprlidj0p/image/upload/v1736417316/kara1_nyvs3r.webp"
                      src="https://res.cloudinary.com/dprlidj0p/image/authenticated/s--Csx9Qjsb--/v1740037101/Standard_1_atoh7v.gif"
                      className={
                        !watchScreen.booster
                          ? "woot-dance"
                          : watchScreen.boosterDetails.name === "5x"
                          ? "woot-dance5x boosterfilter"
                          : watchScreen.boosterDetails.name === "2x"
                          ? "woot-dance2x boosterfilter1"
                          : watchScreen.boosterDetails.name === "3x"
                          ? "woot-dance3x boosterfilter2"
                          : watchScreen.boosterDetails.name === "levelUp"
                          ? "woot-dance boosterfilter3"
                          : "woot-dance boosterfilter4"
                      }
                      alt="shiva"
                    />

                    <div
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        top: 0,
                        left: 0,
                      }}
                    ></div>
                    <img src="https://res.cloudinary.com/dprlidj0p/image/authenticated/s--ywll6_cI--/v1740037097/Lord-Shiva_sucbid.png" />
                  </div> */}

                <div
                  class="image-container"
                  // onTouchStart={handleTapStart}
                  // onTouchEnd={handleTapEnd}
                >
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/stone-png.png"
                    alt="Backside"
                    class="back-image"
                  />
                  <img
                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/shiva-png.png"
                    alt="Frontside"
                    className={`front-image ${isAnimating ? "floating" : ""}`}
                    // className={` front-image floating`}
                    // style={{ left: position.x, top: position.y }}
                  />
                </div>
              </>

              {tapAnimations.map((animation) => (
                <div
                  key={animation.id}
                  className="tap-points holi-animation txt-color"
                  style={{
                    left: animation.x,
                    top: animation.y,
                  }}
                >
                  {IsPointsReached ? (
                    <img src={memetv} alt="Meme TV" style={{ width: "25px" }} />
                  ) : (
                    "+" + basePoints
                  )}
                </div>
              ))}
            </div>
          </div>
          <div ref={scrollableRef}></div>
        </div>
      ) : isEnergyDate ? (
        <ShivRatriPopup
          cancelIcon={cancelIcon}
          IsEnergyPopupClose={IsEnergyPopupClose}
        />
      ) : Is5million ? (
        <FiveMillionPopup userId={userId} setIs5million={setIs5million} />
      ) : IsPointsTable ? (
        <PointsTable userId={userId} setIsPointsTable={setIsPointsTable} />
      
      )
      
      : (
        <div>
          {isLoading && (
            <div className="loaderstyle">
              <div className="spinner"></div>
            </div>
          )}
          <div style={{ position: "relative" }}>
            <div class="background-card"></div>
            <div class="spinning-animation"></div>
            <div
              className="content-card"
              style={{ borderRadius: "13px", border: "1px solid #4CF038" }}
            >
              <div style={{ position: "relative", width: "250px" }}>
                <img
                  src="/tvmeme.png"
                  style={{
                    zIndex: "1",
                    width: "100%",
                    height: "100%",
                    display: "block",
                    borderRadius: "24px",
                  }}
                  alt="Background"
                />
                <div id="black-overlay"></div>
                <h1 className="whats-new" data-text="WHAT'S NEW">
                  WHAT'S NEW
                </h1>
                <div id="black-overlay-bottom"></div>
              </div>
              <div className="text_container">
                <p className="pre_text">DO YOU HAVE A</p>
                <div className="promo-block_div">
                  <h2 className="promo-txt">PROMO</h2>
                  <h2 className="code-txt">CODE</h2>
                </div>
                <p className="unlock_text">UNLOCK NOW!</p>
              </div>
              <button
                disabled={isLoading}
                onClick={() => {
                  NavigateDoEarn();
                }}
                className="redeem-button"
              >
                REDEEM NOW
              </button>
            </div>
            <button
              style={{
                background: "transparent",
                border: "none",
                height: "24px",
              }}
            >
              <img
                onClick={IsPromoClose}
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                className="cancel_button"
              />
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default Tv;
